import React from "react";
import "../css/PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="container-xxl p-0">
      <div className="policy-page">
        <div className="policy-header">
          <h1>PRIVACY POLICY</h1>
          <h2>Bharat Jagriti</h2>
          <p>Effective Date: March 19, 2026 | Last Updated: April 11, 2026</p>
          {/* <p>Effective Date: March 19, 2026 | Last Updated: March 27, 2026</p> */}
        </div>

        <div className="privacy-container">
          <section>
            <h1 className="privacy-title">
              GOOGLE PLAY COMPLIANCE DECLARATION
            </h1>
            <p>
              This Privacy Policy has been prepared in full compliance with the
              Google Play Developer Program Policies, specifically the User Data
              section of the Play Console Help Center. As required by Google
              Play, this policy comprehensively discloses how the Bharat Jagriti
              app collects, accesses, uses, handles, and shares user data,
              including the types of parties with whom it is shared.
            </p>
          </section>
          {/* 1. Introduction */}
          <section>
            <h1 className="privacy-title">1. Introduction</h1>
            <p>
              Welcome to Bharat Jagriti (“App”, “Platform”, “we”, “our”, or
              “us”), a social media application founded by Bhaskar Bhushan &amp;
              developed by GlowApps Private Limited. This Privacy Policy
              explains how we collect, use, store, share, and protect your
              personal information when you use our application or visit our
              website at https://www.bharatjagriti.com.
            </p>
            <p>
              By registering, accessing, or using Bharat Jagriti, you confirm
              that you have read, understood, and agreed to this Privacy Policy.
              If you do not agree, please discontinue use of the application
              immediately.
            </p>
          </section>

          {/* 1A. Recognitions & Institutional Support */}
          <section>
            <h1>1A. Recognitions &amp; Institutional Support</h1>
            <p>
              Bharat Jagriti is proud to be officially recognised and supported
              by leading government initiatives and premier academic
              institutions, underscoring our commitment to innovation,
              transparency, and nation-building.
            </p>
            <ul>
              <li className="liList">
                <span>Startup Bihar :</span>
                <p>
                  Recognised by the Startup Bihar initiative of the Government
                  of Bihar, affirming our contribution to the state's digital
                  and entrepreneurial ecosystem.
                </p>
              </li>
              <li className="liList">
                <span>Startup India :</span>
                <p>
                  Recognised under the Startup India programme of the Government
                  of India, certifying Bharat Jagriti as a legitimate and
                  innovation-driven startup.
                </p>
              </li>
              <li className="liList">
                <span>IIM Kashipur :</span>
                <p>
                  Recognised and supported by the Indian Institute of Management
                  (IIM) Kashipur, one of India's premier management
                  institutions, validating our business model and social impact.
                </p>
              </li>
              <li className="liList">
                <span>Powered by Sripuram :</span>
                <p>
                  Bharat Jagriti is powered by Sripuram, whose support enables
                  us to deliver a reliable, scalable, and values-driven platform
                  to every citizen of India.
                </p>
              </li>
            </ul>
            <p className="privacy_policy_note">
              ✦ These recognitions reflect our dedication to building a
              trustworthy, compliant, and impactful platform. We remain
              committed to upholding the highest standards of governance and
              user privacy in line with the expectations of our institutional
              partners.
            </p>
          </section>

          {/* 2. User */}
          <section>
            <h1>2. User</h1>
            <ul>
              <h2>1. Target users :</h2>
              <p>
                Bharat Jagriti is a social media platform made for all citizens
                of India except children under age 13.
              </p>
            </ul>
            <ul>
              <h2>2. User Consent</h2>
              <p>
                Before collecting any personal or sensitive data, Bharat Jagriti
                will display a clear, prominent, and unambiguous consent dialog
                within the app. This consent:
              </p>
              <ul>
                <li>Is shown before any data collection begins</li>
                <li>
                  Requires an affirmative action from you (e.g., tapping 'I
                  Agree' or checking a checkbox)
                </li>
                <li>Clearly explains what data is being collected and why</li>
                <li>Cannot be bypassed or pre-checked</li>
                <li>Is separate from the Terms of Service acceptance</li>
              </ul>
              <p>
                You may withdraw your consent at any time by contacting us at
                ceo@bharatjagriti.com or by deleting your account. Withdrawal of
                consent may affect your ability to use certain features of the
                app.
              </p>
            </ul>
          </section>

          {/* 3. Information We Collect */}
          <section>
            <h1>3. Information We Collect</h1>
            <ul>
              <h2>3.1 Information You Provide During Registration</h2>
              <p>
                When you create an account, we collect the following personal
                information:
              </p>
              <ul>
                <li>Full Name</li>
                <li>Mobile Number (used for OTP-based login/signup)</li>
                <li>Email Address</li>
                <li>
                  State and District (for location-based content delivery)
                </li>
                <li>Gender</li>
                <li>Age</li>
                <li>Password (stored in encrypted form)</li>
              </ul>
            </ul>
            <ul>
              <h2>3.2 KYC (Know Your Customer) Information</h2>
              <p>
                To enable the monetization withdrawal features of the platform
                and to send money to the user, we collect KYC information
                strictly as per the compliance of the Indian government. The
                following information is collected:
              </p>
              <ul>
                <li>
                  Aadhaar Number — collected only for identity verification; no
                  photocopy or scanned image is stored after verification is
                  completed.
                </li>
                <li>
                  PAN Card number (optional) — for tax compliance and withdrawal
                  processing
                </li>
                <li>
                  Bank Account Details (account number, IFSC code, account
                  holder name)
                </li>
                <li>UPI ID or QR/Scanner details (for donation features)</li>
              </ul>
            </ul>
            <ul>
              <h2>3.2.1 Why We Collect Aadhaar — Legal Justification</h2>
              <p>
                Bharat Jagriti collects your Aadhaar number in compliance with
                UIDAI guidelines, the Aadhaar Act, 2016, and the Digital
                Personal Data Protection Act, 2023. Aadhaar details are
                collected only when you voluntarily initiate a withdrawal
                request or when required for user identity verification to
                provide a verification badge.
              </p>
              <ul>
                <li className="liList">
                  <span>Purpose :</span>
                  <p>
                    Identity verification to prevent fraud and comply with
                    financial regulations.
                  </p>
                </li>
                <li className="liList">
                  <span>Legal Basis :</span>
                  <p>
                    Collection is based on your free, informed, and explicit
                    consent given at the time of KYC submission, as required
                    under the Digital Personal Data Protection Act, 2023
                    (Section 6) and the Aadhaar Act, 2016 (Section 8).
                  </p>
                </li>
              </ul>
              <p className="privacy_policy_note">
                ■ Note: Aadhaar data is collected strictly in compliance with
                UIDAI guidelines and is NEVER stored beyond what is required by
                law. The data is encrypted at rest, tokenized after
                verification, and permanently deleted once the legal retention
                period expires. You may submit Masked Aadhaar as a safer
                alternative — we accept it.
              </p>
            </ul>
            <ul>
              <h2>3.2.2 Aadhaar Data — Full UIDAI Compliance Rules</h2>
              <p>
                Bharat Jagriti handles Aadhaar data strictly in accordance with
                UIDAI's latest guidelines (UIDAI Circular No. 8 of 2025) and the
                Aadhaar (Data Security) Regulations, 2016:
              </p>
              <ul>
                <li className="liList">
                  <span>Purpose Limitation :</span>
                  <p>
                    Your Aadhaar number is used SOLELY for identity verification
                    before processing a withdrawal.
                  </p>
                </li>
                <li className="liList">
                  <span>Voluntary Submission :</span>
                  <p>
                    Providing Aadhaar is completely voluntary. You may use PAN
                    Card, Voter ID, or Passport as alternative KYC documents.
                  </p>
                </li>
                <li className="liList">
                  <span>Encrypted Storage :</span>
                  <p>
                    Aadhaar numbers are stored using AES-256 encryption. Raw
                    Aadhaar numbers are never stored in plain text or
                    unencrypted databases.
                  </p>
                </li>
                <li className="liList">
                  <span>Tokenization :</span>
                  <p>
                    Your Aadhaar number is replaced with a secure encrypted
                    token after verification.
                  </p>
                </li>
                <li className="liList">
                  <span>Access Control :</span>
                  <p>
                    Aadhaar data is accessible only to authorized admin
                    personnel on a strict need-to-know basis.
                  </p>
                </li>
                <li className="liList">
                  <span>No Third-Party Sharing :</span>
                  <p>
                    Your Aadhaar number is never sold, rented, or shared with
                    any unauthorized third party.
                  </p>
                </li>
                <li className="liList">
                  <span>Third Party API :</span>
                  <p>
                    Bharat Jagriti uses DIGIO as third party API for purpose aadhar 
                    authentication or e-KYC services.
                  </p>
                </li>
                <li className="liList">
                  <span>Retention &amp; Deletion :</span>
                  <p>
                    Aadhaar data is retained only for the minimum period
                    required under applicable Indian law and is securely and
                    permanently deleted thereafter.
                  </p>
                </li>
              </ul>
            </ul>
            <ul>
              <h2>
                3.2.3 UPI ID and Payment Scanner — Donation Feature
                Clarification
              </h2>
              <p>
                Bharat Jagriti includes a donation feature that allows users to
                receive donations from supporters:
              </p>
              <ul>
                <li className="liList">
                  <span>What we collect:</span>
                  <p>
                    Your UPI ID (text, e.g. name@upi) OR your payment QR
                    code/scanner image — whichever you choose to add to your
                    profile.
                  </p>
                </li>
                <li className="liList">
                  <span>How it works:</span>
                  <p>
                    When a donor taps your UPI ID or scanner, they are
                    redirected to their own installed payment app (Google Pay,
                    PhonePe, Paytm, or any UPI-enabled app) to complete the
                    donation.
                  </p>
                </li>
                <li className="liList">
                  <span>No In-App Payments :</span>
                  <p>
                    Bharat Jagriti does NOT process, handle, hold, or transfer
                    any payment or money within the app.
                  </p>
                </li>
                <li className="liList">
                  <span>No Payment Data Collected:</span>
                  <p>
                    We do not collect, store, or see any payment transaction
                    details, donor card numbers, bank credentials, or
                    transaction IDs.
                  </p>
                </li>
                <li className="liList">
                  <span>Scanner Image Storage :</span>
                  <p>
                    If you upload a QR/scanner image, it is stored securely and
                    displayed only on your profile for donors to scan.
                  </p>
                </li>
                <li className="liList">
                  <span>Voluntary Feature:</span>
                  <p>Adding UPI ID or scanner is completely optional.</p>
                </li>
              </ul>
              <p className="privacy_policy_note">
                ■ Note: Bharat Jagriti is NOT a payment platform. All actual
                payment transactions happen entirely within the donor's own
                payment app. We only display your UPI ID or scanner as a
                convenience link — we never touch, process, or store any payment
                transaction data.
              </p>
            </ul>
            <ul>
              <h2>
                3.2.4 Bank Account Details — What We Collect and What We Don't
              </h2>
              <ul>
                <li className="liList">
                  <span>What we collect (text only):</span>
                  <p>
                    Account holder name, bank account number, IFSC code, and
                    bank name.
                  </p>
                </li>
                <li className="liList">
                  <span>What we do NOT collect:</span>
                  <p>
                    No bank statement images, no cheque images, no passbook
                    scans, no screenshots — only the text details you type in.
                  </p>
                </li>
                <li className="liList">
                  <span>Purpose :</span>
                  <p>
                    Bank details are used exclusively to transfer your earned
                    monetization amount to your account via standard bank
                    transfer.
                  </p>
                </li>
                <li className="liList">
                  <span>Security :</span>
                  <p>
                    Bank details are stored in AES-256 encrypted form with
                    restricted admin-only access.
                  </p>
                </li>
                <li className="liList">
                  <span>No Payment Processing:</span>
                  <p>
                    Bharat Jagriti does not process any payments or transactions
                    within the app.
                  </p>
                </li>
                <li className="liList">
                  <span>No Third-Party Sharing:</span>
                  <p>
                    Your bank details are never shared with any unauthorized
                    third party, advertiser, or external service.
                  </p>
                </li>
              </ul>
            </ul>
            <ul>
              <h2>
                3.2.5 PAN Card — Optional Collection &amp; Legal Requirement
              </h2>
              <ul>
                <li className="liList">
                  <span>What We Collect:</span>
                  <p>
                    Only the 10-character alphanumeric PAN number (e.g.
                    ABCDE1234F) entered as text. We do NOT collect any image,
                    scan, photocopy, or document of your PAN card.
                  </p>
                </li>
                <li className="liList">
                  <span>Is It Optional? :</span>
                  <p>
                    Yes. PAN card number is completely optional for standard
                    withdrawals unless your total withdrawal amount exceeds
                    ₹50,000.
                  </p>
                </li>
                <li className="liList">
                  <span>When Does It Become Mandatory? :</span>
                  <p>
                    As per Section 139A of the Income Tax Act, 1961 and Rule
                    114B of the Income Tax Rules, PAN is mandatory for any
                    financial transaction exceeding ₹50,000 in a single
                    instance.
                  </p>
                </li>
                <li className="liList">
                  <span>Encrypted Storage:</span>
                  <p>
                    PAN numbers are stored using AES-256 encryption with
                    restricted admin-only access.
                  </p>
                </li>
                <li className="liList">
                  <span>No Third-Party Sharing:</span>
                  <p>
                    Your PAN number is never sold, rented, or shared with any
                    unauthorized party.
                  </p>
                </li>
                <li className="liList">
                  <span>Retention :</span>
                  <p>
                    PAN data is retained for the period required under the
                    Income Tax Act, then permanently deleted.
                  </p>
                </li>
              </ul>
              <p className="privacy_policy_note">
                ■ Note: PAN card number is OPTIONAL for withdrawals below
                ₹50,000. It becomes mandatory only when your withdrawal exceeds
                ₹50,000, as required under Section 139A of the Income Tax Act,
                1961.
              </p>
            </ul>
          </section>

          {/* 3.3 Content You Create */}
          <ul>
            <h2>3.3 Content You Create</h2>
            <p>
              We collect and store content you voluntarily submit on the
              platform, including:
            </p>
            <ul>
              <li>Posts, news articles, and text content</li>
              <li>Images and videos uploaded to feeds</li>
              <li>Revolution content (text, images, videos)</li>
              <li>Comments and digital signatures on Revolutions</li>
              <li>
                Interactions such as likes, follows, shares, and support actions
              </li>
            </ul>
          </ul>

          {/* 3.4 Technical and Device Information */}
          <ul>
            <h2>3.4 Technical and Device Information</h2>
            <ul>
              <li>Device type, operating system, and app version</li>
              <li>IP address and network information</li>
              <li>App usage logs, session duration, and activity timestamps</li>
              <li>Crash reports and diagnostic data</li>
            </ul>
          </ul>

          {/* 3.5 Third-Party API Data */}
          <ul>
            <h2>3.5 Third-Party API Data</h2>
            <p>
              The app integrates the YouTube API to display live video content
              within the platform. When you view YouTube live videos, you may be
              subject to YouTube's own Privacy Policy
              (https://policies.google.com/privacy). We do not collect your
              YouTube account data or credentials.
            </p>
          </ul>

          {/* 3A. Spam Control & Anti-Fraud Measures */}
          <section>
            <h1>3A. Spam Control &amp; Anti-Fraud Measures</h1>
            <p>
              Bharat Jagriti employs a robust, multi-layered spam control
              framework to maintain the integrity of the platform, protect
              genuine users, and ensure a safe and authentic social media
              experience for every citizen of India.
            </p>
            <ul>
              <h2>3A.1 Mobile Number-Based Login &amp; One-Account Policy</h2>
              <p>
                Every user account on Bharat Jagriti is uniquely linked to a
                single verified mobile number. This forms the foundation of our
                anti-spam and anti-fake-account policy:
              </p>
              <ul>
                <li className="liList">
                  <span>One Mobile Number, One Account :</span>
                  <p>
                    Each mobile number can only be registered to a single user
                    account. Duplicate or multiple accounts using the same
                    number are strictly prohibited and automatically rejected.
                  </p>
                </li>
                <li className="liList">
                  <span>OTP-Based Verification :</span>
                  <p>
                    Every registration and login is authenticated via a One-Time
                    Password (OTP) sent to the registered mobile number. This
                    ensures that only the genuine owner of the mobile number can
                    access or create an account.
                  </p>
                </li>
                <li className="liList">
                  <span>No Anonymous Accounts :</span>
                  <p>
                    Accounts cannot be created without a valid, OTP-verified
                    mobile number, eliminating anonymous or throwaway accounts.
                  </p>
                </li>
                <li className="liList">
                  <span>Unique Identity Enforcement:</span>
                  <p>
                    Every user ID on the platform is uniquely bound to a single
                    mobile number, creating a one-to-one mapping that prevents
                    mass account creation or bot registrations.
                  </p>
                </li>
              </ul>
            </ul>
            <ul>
              <h2>3A.2 Government ID Verification &amp; Post Reach Policy</h2>
              <p>
                To further strengthen platform authenticity and reduce spam,
                Bharat Jagriti incentivises users to verify their identity using
                a valid Government-issued ID.
              </p>
              <ul>
                <li className="liList">
                  <span>Government ID Verification :</span>
                  <p>
                    Users are encouraged to complete identity verification using
                    an accepted Government ID proof (such as Aadhaar, Voter ID,
                    or Passport).
                  </p>
                </li>
                <li className="liList">
                  <span>Verified Users Get Full Reach :</span>
                  <p>
                    Users who complete Government ID verification enjoy full
                    post visibility and reach across the platform's feeds and
                    recommendation systems.
                  </p>
                </li>
                <li className="liList">
                  <span>Unverified Users — Reduced Reach :</span>
                  <p>
                    Users who choose not to submit Government ID verification
                    will have their post reach significantly limited. Their
                    content will have minimum visibility in public feeds,
                    protecting other users from potential spam or inauthentic
                    content.
                  </p>
                </li>
                <li className="liList">
                  <span>Verification Badge :</span>
                  <p>
                    Verified users receive a verification badge on their
                    profile, signalling authenticity and trustworthiness to
                    other users and the platform.
                  </p>
                </li>
              </ul>
              <p className="privacy_policy_note">
                ■ Note: Government ID verification is voluntary. However,
                unverified users will experience significantly reduced post
                reach and platform visibility as a spam-prevention measure.
              </p>
            </ul>
            <ul>
              <h2>3A.3 AI &amp; Algorithm-Based Spam Detection</h2>
              <p>
                Bharat Jagriti deploys advanced AI models and proprietary
                algorithms to continuously monitor, detect, and neutralise spam
                and fraudulent activity across the platform:
              </p>
              <ul>
                <li className="liList">
                  <span>Behavioural Analysis :</span>
                  <p>
                    Our AI systems analyse user behaviour patterns — such as
                    posting frequency, content repetition, engagement anomalies,
                    and suspicious interaction patterns — to identify and flag
                    potential spam accounts.
                  </p>
                </li>
                <li className="liList">
                  <span>Duplicate Account Detection :</span>
                  <p>
                    Algorithms cross-reference mobile numbers, device
                    fingerprints, and account metadata to detect and remove
                    duplicate or coordinated fake accounts.
                  </p>
                </li>
                <li className="liList">
                  <span>Content Spam Detection :</span>
                  <p>
                    Machine learning models scan posts and comments for
                    spam-like content, automated or bot-generated text,
                    coordinated inauthentic behaviour, and policy-violating
                    material.
                  </p>
                </li>
                <li className="liList">
                  <span>Real-Time Monitoring :</span>
                  <p>
                    The platform continuously monitors activity in real time,
                    enabling rapid response to emerging spam campaigns or
                    coordinated abuse attempts.
                  </p>
                </li>
                <li className="liList">
                  <span>Fraud Prevention :</span>
                  <p>
                    AI-powered systems flag suspicious withdrawal requests,
                    unusually rapid follower growth, and other indicators of
                    platform manipulation or financial fraud.
                  </p>
                </li>
                <li className="liList">
                  <span>Adaptive Learning :</span>
                  <p>
                    Our spam detection models are continuously updated and
                    retrained as new spam tactics emerge, ensuring the platform
                    remains resilient against evolving threats.
                  </p>
                </li>
              </ul>
              <p className="privacy_policy_note">
                ✦ Our commitment: A platform where every voice is real, every
                account is authentic, and every interaction is genuine. Bharat
                Jagriti's spam control systems work silently in the background
                to protect your experience and the integrity of the community.
              </p>
            </ul>
          </section>

          {/* 4. Device Permissions */}
          <section>
            <h1>4. Device Permissions</h1>
            <p>
              Bharat Jagriti requests only the minimum permissions necessary to
              provide app features. We follow a permission-first approach — the
              app will always ask for your explicit permission before accessing
              any device feature. Camera and Gallery are NEVER accessed
              automatically or in the background.
            </p>
            <ul>
              <h2>4.1 Camera Permission</h2>
              <p>
                When you choose to upload a photo or video by tapping the camera
                option, the app will display a permission request dialog. Camera
                is accessed ONLY when you actively tap the camera/upload button
                and is NEVER accessed in the background or without your action.
                You can revoke camera permission anytime via your device
                Settings → Apps → Bharat Jagriti → Permissions.
              </p>
            </ul>
            <ul>
              <h2>4.2 Storage / Gallery Permission</h2>
              <p>
                When you choose to upload a photo or video from your gallery,
                the app will display a permission request dialog. Gallery is
                accessed ONLY when you actively tap the gallery/upload button.
                We only access the specific file you select — not your entire
                gallery. We do NOT scan, read, or store any other media files on
                your device.
              </p>
            </ul>
            <p className="privacy_policy_note">
              ■ Note: Both Camera and Gallery permissions are optional. You can
              still use the app without granting these permissions; however, you
              will not be able to upload photos or videos.
            </p>
          </section>

          {/* 5. How We Use Your Information */}
          <section>
            <h1>5. How We Use Your Information</h1>
            <p>
              We use the information collected strictly for the following
              purposes:
            </p>
            <ul>
              <li className="liList">
                <span>Account Creation &amp; Authentication :</span>
                <p>
                  To register your account and verify your identity using
                  OTP-based authentication.
                </p>
              </li>
              <li className="liList">
                <span>Content Delivery :</span>
                <p>
                  To display personalised Prime Feed and Public Feed content
                  based on your state, district, and preferences.
                </p>
              </li>
              <li className="liList">
                <span>Monetization :</span>
                <p>
                  To calculate and process earnings based on likes, followers,
                  and engagement metrics as per our monetization policy.
                </p>
              </li>
              <li className="liList">
                <span>Withdrawals &amp; KYC :</span>
                <p>
                  To verify your identity and process withdrawal requests
                  securely through the admin panel.
                </p>
              </li>
              <li className="liList">
                <span>Donation Feature :</span>
                <p>
                  To facilitate donations using your UPI ID or scanner details
                  as provided by you.
                </p>
              </li>
              <li className="liList">
                <span>Revolution Module :</span>
                <p>
                  To manage your participation in, support for, and creation of
                  Revolution campaigns.
                </p>
              </li>
              <li className="liList">
                <span>Platform Safety :</span>
                <p>
                  To detect fraud, abuse, spam, and violations of our Terms of
                  Service.
                </p>
              </li>
              <li className="liList">
                <span>Customer Support :</span>
                <p>To respond to your queries, complaints, or requests.</p>
              </li>
              <li className="liList">
                <span>Legal Compliance :</span>
                <p>
                  To comply with applicable laws, regulations, and lawful
                  government requests.
                </p>
              </li>
              <li className="liList">
                <span>Platform Improvement :</span>
                <p>
                  To analyse usage patterns and improve features and performance
                  of the app.
                </p>
              </li>
            </ul>
          </section>

          {/* 6. Data Sharing and Disclosure */}
          <section>
            <h1>6. Data Sharing and Disclosure</h1>
            <p>
              Bharat Jagriti does NOT sell, rent, or trade your personal
              information to any third party. We may share your data only in the
              following limited and necessary circumstances:
            </p>
            <ul>
              <li className="liList">
                <span>With Platform Administrators :</span>
                <p>
                  Admin personnel have access to user data solely for managing
                  the platform, approving revolutions, and processing
                  withdrawals.
                </p>
              </li>
              <li className="liList">
                <span>With Payment/Banking Partners:</span>
                <p>
                  Bank details and KYC information may be shared with authorised
                  financial institutions strictly for processing withdrawal
                  transactions.
                </p>
              </li>
              <li className="liList">
                <span>With Legal Authorities :</span>
                <p>
                  We may disclose information if required by law, court order,
                  or a legitimate government regulation.
                </p>
              </li>
              <li className="liList">
                <span>For Safety Purposes :</span>
                <p>
                  To protect the rights, safety, or property of Bharat Jagriti,
                  its users, or the general public.
                </p>
              </li>
              <li className="liList">
                <span>Business Transfers :</span>
                <p>
                  In the event of a merger, acquisition, or sale of assets, your
                  data may be transferred to the new entity under equivalent
                  privacy protections.
                </p>
              </li>
              <li className="liList">
                <span>YouTube API :</span>
                <p>
                  Live video content is served via YouTube's API. YouTube's own
                  privacy policy governs such content.
                </p>
              </li>
            </ul>
          </section>

          {/* 7. Data Retention */}
          <section>
            <h1>7. Data Retention</h1>
            <p>
              We retain your personal information for as long as your account is
              active or as needed to provide services. Specifically:
            </p>
            <ul>
              <li>
                Account data is retained for the duration of your account's
                existence.
              </li>
              <li>
                KYC documents are retained as required by applicable Indian
                financial and regulatory laws.
              </li>
              <li>
                Revolution participation records and digital signatures are
                stored permanently as they constitute a public record of civic
                participation.
              </li>
              <li>
                Content (posts, images, videos) is retained until deleted by the
                user or removed by an admin.
              </li>
              <li>
                Upon successful account deletion, your personal data will be
                permanently deleted within 30 days, except where retention is
                mandated by law.
              </li>
            </ul>
          </section>

          {/* 8. Account Deletion */}
          <section>
            <h1>8. Account Deletion</h1>
            <p>
              As required by Google Play Store policy, Bharat Jagriti provides
              users with the ability to request deletion of their account and
              associated personal data.
            </p>
            <ul>
              <h2>8.1 How to Delete Your Account</h2>
              <p>
                You can delete your account using any of the following methods:
              </p>
              <ul>
                <li className="liList">
                  <span>In-App :</span>
                  <p>
                    Go to Profile Settings → Delete Account and follow the
                    on-screen instructions.
                  </p>
                </li>
                <li className="liList">
                  <span>Via Email :</span>
                  <p>
                    Send a deletion request to ceo@bharatjagriti.com with your
                    registered mobile number.
                  </p>
                </li>
                <li className="liList">
                  <span>Via Website :</span>
                  <p>
                    Visit https://www.bharatjagriti.com/ and use the account
                    deletion request form.
                  </p>
                </li>
              </ul>
            </ul>
            <ul>
              <h2>8.2 What Happens After Deletion</h2>
              <ul>
                <li>
                  Your account and personal profile data will be permanently
                  deleted within 30 days of the request.
                </li>
                <li>
                  Your posts, content, and media will be removed from the
                  platform.
                </li>
                <li>
                  Any pending monetization balance must be withdrawn before
                  account deletion.
                </li>
                <li>
                  Revolution participation records and digital signatures may be
                  retained but will be anonymised.
                </li>
                <li>
                  KYC data will be retained for the period required by
                  applicable Indian law, then permanently deleted.
                </li>
              </ul>
              <p className="privacy_policy_note">
                ■ Note: Account deletion is permanent and cannot be undone. Make
                sure to withdraw any pending balance before submitting your
                deletion request.
              </p>
            </ul>
          </section>

          {/* 9. Data Security */}
          <section>
            <h1>9. Data Security</h1>
            <p>
              We implement industry-standard security measures to protect your
              data, including:
            </p>
            <ul>
              <li>Encrypted storage of passwords and sensitive information</li>
              <li>Secure HTTPS connections for all data transmission</li>
              <li>
                Access controls limiting data access to authorised personnel
                only
              </li>
              <li>
                Secure storage of KYC documents with restricted admin access
              </li>
              <li>Regular security audits and platform monitoring</li>
            </ul>
            <p>
              While we take all reasonable precautions, no method of
              transmission over the internet is 100% secure. You are encouraged
              to use a strong, unique password and to log out after each
              session.
            </p>
          </section>

          {/* 10. User Rights */}
          <section>
            <h1>10. User Rights</h1>
            <p>
              Users have the following rights with respect to your personal
              data:
            </p>
            <ul>
              <li className="liList">
                <span>Right to Access :</span>
                <p>
                  You may request a copy of the personal data we hold about you.
                </p>
              </li>
              <li className="liList">
                <span>Right to Correction :</span>
                <p>
                  You may update or correct your personal information through
                  your account settings.
                </p>
              </li>
              <li className="liList">
                <span>Right to Deletion :</span>
                <p>
                  You may request permanent deletion of your account and
                  associated personal data (see Section 8).
                </p>
              </li>
              <li className="liList">
                <span>Right to Withdraw Consent :</span>
                <p>
                  You may withdraw consent for specific data uses at any time,
                  subject to legal obligations.
                </p>
              </li>
              <li className="liList">
                <span>Right to Data Portability :</span>
                <p>
                  You may request a machine-readable copy of your personal data.
                </p>
              </li>
              <li className="liList">
                <span>Right to Object :</span>
                <p>
                  You may object to processing of your personal data for certain
                  purposes.
                </p>
              </li>
              <li className="liList">
                <span>Right to Lodge a Complaint :</span>
                <p>
                  You may contact us or approach the relevant data protection
                  authority if you believe your rights have been violated.
                </p>
              </li>
            </ul>
            <p>
              To exercise any of these rights, please contact:
              ceo@bharatjagriti.com
            </p>
          </section>

          {/* 11. Children's Privacy */}
          <section>
            <h1>11. Children's Privacy</h1>
            <p>
              Bharat Jagriti is not intended for use by individuals under the
              age of 13. We do not knowingly collect personal information from
              children under 13. If we become aware that a child under 13 has
              provided us with personal data, we will take immediate steps to
              delete such information. If you are a parent or guardian and
              believe your child has registered on our platform, please contact
              us immediately at ceo@bharatjagriti.com.
            </p>
          </section>

          {/* 12. Cookies and Tracking Technologies */}
          <section>
            <h1>12. Cookies and Tracking Technologies</h1>
            <p>
              Our website (https://www.bharatjagriti.com/) may use cookies and
              similar technologies to improve your browsing experience, maintain
              session integrity, and analyse website traffic. You may disable
              cookies through your browser settings; however, this may affect
              certain functionalities of the website.
            </p>
          </section>

          {/* 13. Monetization and Financial Data */}
          <section>
            <h1>13. Monetization and Financial Data</h1>
            <p>
              Bharat Jagriti offers a powerful and transparent monetization
              programme for both Prime Users and Public Users, enabling
              creators, journalists, and civic contributors to earn real income
              directly from their work on the platform. We treat your financial
              data with the highest level of responsibility, security, and legal
              compliance.
            </p>
            <ul>
              <h2>13.1 How Monetization Works</h2>
              <p>
                Users earn monetization rewards based on their engagement
                metrics — including likes, followers, post reach, and platform
                activity — as per Bharat Jagriti's monetization policy. Earnings
                are calculated transparently through the platform's admin panel
                and are available for withdrawal once the user has completed
                full KYC verification.
              </p>
              <ul>
                <li className="liList">
                  <span>Prime Users:</span>
                  <p>
                    are eligible for an enhanced monetization tier with higher
                    earning potential based on their subscription level and
                    engagement.
                  </p>
                </li>
                <li className="liList">
                  <span>Public Users :</span>
                  <p>
                    are eligible for the standard monetization programme based
                    on their content engagement and follower metrics.
                  </p>
                </li>
                <li className="liList">
                  <span>Donation Feature :</span>
                  <p>
                    Users may additionally receive direct donations from
                    supporters via their linked UPI ID or payment scanner
                    displayed on their profile.
                  </p>
                </li>
                <li className="liList">
                  <span>Earnings Transparency :</span>
                  <p>
                    All monetization calculations are logged and accessible to
                    the user through their account dashboard.
                  </p>
                </li>
                <li>
                  <strong>NOTE :</strong>{" "}
                  Bharat Jagriti does not claim monetization as a guaranteed source of income. It solely depends on the company's profit and loss.
                  Monetization will be approved only for posts created by users themselves. Copyrighted or downloaded posts will not be Approved by Admin for monetization at the Time of Claim Settlement.
              </li>
              </ul>
            </ul>
            <ul>
              <h2>13.2 Financial Data — Collection and Security</h2>
              <p>
                Financial data — including bank account details and UPI
                information — is collected solely for the purpose of processing
                withdrawals and donations. Bharat Jagriti maintains the
                strictest standards of financial data security in compliance
                with applicable Indian law.
              </p>
              <ul>
                <li className="liList">
                  <span>AES-256 Encryption :</span>
                  <p>
                    All financial data is stored using AES-256 military-grade
                    encryption at rest. Raw financial details are never stored
                    in plain text or unencrypted databases.
                  </p>
                </li>
                <li className="liList">
                  <span>Restricted Access :</span>
                  <p>
                    Financial data is accessible only to authorised admin
                    personnel on a strict need-to-know basis. No other employee,
                    contractor, or third party has access.
                  </p>
                </li>
                <li className="liList">
                  <span>No Unauthorised Sharing :</span>
                  <p>
                    Financial data is never sold, rented, shared, or disclosed
                    to any unauthorised third party, advertiser, or external
                    service under any circumstances.
                  </p>
                </li>
                <li className="liList">
                  <span>Purpose Limitation :</span>
                  <p>
                    Bank account details and UPI information are used
                    exclusively for processing withdrawal transactions and
                    donation facilitation — for no other purpose whatsoever.
                  </p>
                </li>
                <li className="liList">
                  <span>KYC-Gated Withdrawals :</span>
                  <p>
                    No withdrawal is processed without prior successful KYC
                    verification, ensuring that funds are transferred only to
                    the verified, rightful account holder.
                  </p>
                </li>
                <li className="liList">
                  <span>Regulatory Compliance :</span>
                  <p>
                    All financial data handling, retention, and deletion is
                    carried out in full compliance with the Digital Personal
                    Data Protection Act, 2023, the Income Tax Act, 1961, and
                    applicable RBI and UIDAI guidelines.
                  </p>
                </li>
                <li className="liList">
                  <span>No In-App Payment Processing :</span>
                  <p>
                    Bharat Jagriti does not process, hold, or transfer payments
                    within the app. All bank transfers are executed via
                    authorised financial institutions and standard banking
                    channels.
                  </p>
                </li>
              </ul>
            </ul>
            <ul>
              <h2>13.3 Withdrawal Policy</h2>
              <p>
                Withdrawals are subject to the following strict conditions to
                protect users and maintain platform integrity:
              </p>
              <ul>
                <li>
                  Withdrawals are processed only after successful KYC
                  verification (Aadhaar, PAN where applicable, and bank account
                  details) and reaching the threshold limit in wallet as per
                  company terms and conditions. The threshold limit is clearly
                  mentioned on the monetization dashboard / withdrawal button.
                </li>
                <li>
                  Withdrawal requests are reviewed and approved by the admin
                  panel before funds are released. The fund will be credited to
                  the bank account of the user within 60 to 120 days of approval
                  by the admin.
                </li>
                <li>
                  PAN card details are mandatory for any withdrawal exceeding
                  ₹50,000, as required under Section 139A of the Income Tax Act,
                  1961.
                </li>
                <li>
                  Any pending monetization balance must be withdrawn before
                  account deletion — Bharat Jagriti is not liable for unclaimed
                  balances after account deletion.
                </li>
                <li>
                  Bharat Jagriti reserves the right to withhold or suspend
                  withdrawals in cases of suspected fraud, policy violations, or
                  legal compliance requirements.
                </li>
                <li>
                  The wallet balance reflects an indicative value based on current platform records and should not be considered a confirmed settlement amount.
                </li>
                <li>
                  Final settlement is subject to the platform’s internal assessment and applicable verification procedures.
                </li>
                <li>
                  Submitted content may undergo a quality, eligibility, and compliance review before the settlement process is completed.
                </li>
                  <li>
                  The amount eligible for settlement may vary depending on the outcome of the review and the applicable platform policies.
                </li>
                  <li>
                  Any settlement shall be processed in accordance with the platform’s terms, verification standards, and final approval procedures.
                </li>
                <li>
                  All withdrawals are subject to applicable Indian tax
                  deductions at source (TDS) as required by law.
                </li>
              </ul>
            </ul>
            <ul>
              <h2>13.4 Fraud Prevention and Financial Integrity</h2>
              <p>
                Bharat Jagriti employs rigorous fraud prevention mechanisms to
                protect the financial integrity of the monetization system and
                the safety of every user's earnings:
              </p>
              <ul>
                <li className="liList">
                  <span>Identity Verification :</span>
                  <p>
                    Every withdrawal request is cross-verified against the
                    user's KYC-verified identity before processing. Unverified
                    or mismatched details will result in withdrawal suspension.
                  </p>
                </li>
                <li className="liList">
                  <span>AI-Powered Fraud Detection :</span>
                  <p>
                    Our AI systems continuously monitor withdrawal requests and
                    monetization activity for suspicious patterns, including
                    artificially inflated engagement metrics, fake followers, or
                    coordinated manipulation.
                  </p>
                </li>
                <li className="liList">
                  <span>One Account Per User :</span>
                  <p>
                    The one-mobile-number-one-account policy ensures that no
                    single individual can create multiple accounts to
                    fraudulently accumulate monetization earnings.
                  </p>
                </li>
                <li className="liList">
                  <span>Engagement Authenticity :</span>
                  <p>
                    Monetization earnings are calculated only on the basis of
                    genuine, verified user engagement. Fake likes, bot-generated
                    follows, or artificially boosted metrics will be
                    disqualified and may result in account suspension.
                  </p>
                </li>
                <li className="liList">
                  <span>Legal Action :</span>
                  <p>
                    Any attempt to defraud the monetization system — including
                    submitting false KYC details, manipulating engagement
                    metrics, or making fraudulent withdrawal requests — will
                    result in permanent account termination and may be reported
                    to law enforcement authorities.
                  </p>
                </li>
              </ul>
              <p className="privacy_policy_note">
                ■ Important: Bharat Jagriti's monetization system is built on
                the principles of authenticity, transparency, and fairness. Only
                genuine content creators with real followers and real engagement
                will earn and withdraw. Any attempt to game, manipulate, or
                defraud the system will be detected, penalised, and reported.
                Your earnings are safe — and so is the platform.
              </p>
            </ul>
            <ul>
              <h2>13.5 Monetization Content Policy</h2>
    {/* 1. Introduction and Purpose */}
            <h3>1. Introduction and Purpose</h3>
            <p>
              Bharat Jagriti is a platform where users share their views,
              knowledge and creativity. The monetization feature exists to
              reward creators who publish original, valuable content. This
              policy explains which posts qualify for monetization, which do
              not, and what happens when the rules are broken.
            </p>

          {/* 2. Who This Policy Applies To */}
            <h3>2. Who This Policy Applies To</h3>
            <p>
              This policy applies to every user who turns on monetization for a
              post. By enabling monetization, the user confirms that they have
              read this policy and agree to follow it.
            </p>

          {/* 3. Core Eligibility Rule */}
            <h3>3. Core Eligibility Rule</h3>
            <p>
              A monetized post is approved and paid only if it meets all three
              conditions below:
            </p>
            <ol>
              <li>The content is original and created by the user.</li>
              <li>
                The post falls under one of the eligible content categories in
                Section 5 and meets the format requirements in Section 6.
              </li>
              <li>
                The post contains nothing listed under &quot;Content Not
                Eligible for Monetization&quot; (Section 7) or &quot;Additional
                Prohibited Content&quot; (Section 9).
              </li>
            </ol>
            <p>
              A post that fails any of these conditions is not treated as a
              monetized post and is not paid.
            </p>

          {/* 4. Recommended Content */}
            <h3>4. Recommended Content (First Priority)</h3>
            <p>
              Political Content is the most preferred category on Bharat
              Jagriti. It includes:
            </p>
            <ul>
              <li>
                Opinions, analysis and commentary on politics and governance
              </li>
              <li>
                Information about, or review of, government schemes, policies
                and public decisions
              </li>
              <li>Awareness about social and national issues</li>
              <li>Lawful political content, as per the Constitution of India, including the right to expression, right to speech, right to freedom, and right to work and travel.</li>
            </ul>
            <p>
              Political content must be based on facts, must be free of abuse,
              violence and must not spread false and misleading information or
              hatred against any person, group or community.
            </p>

          {/* 5. Eligible Content Categories */}
            <h3>5. Eligible Content Categories</h3>
            <p>
              Apart from Political Content, the following categories are
              eligible for monetization, provided the content is original and
              meets Section 6:
            </p>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>What it includes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Comedy</td>
                    <td>Clean, original humour</td>
                  </tr>
                  <tr>
                    <td>Informative Content</td>
                    <td>
                      Useful information, news-based analysis, tips and
                      explainers
                    </td>
                  </tr>
                  <tr>
                    <td>Educational Content</td>
                    <td>
                      Studies, career guidance, skill learning, exam
                      preparation
                    </td>
                  </tr>
                  <tr>
                    <td>Entertainment</td>
                    <td>Original entertainment content</td>
                  </tr>
                  <tr>
                    <td>Awareness-related Content</td>
                    <td>
                      Health, social, legal, financial and environmental
                      awareness
                    </td>
                  </tr>
                  <tr>
                    <td>Food Content</td>
                    <td>Original recipes, cooking tips and food reviews</td>
                  </tr>
                  <tr>
                    <td>Bhakti Content</td>
                    <td>
                      Bhajans, devotional and spiritual thoughts that respect
                      all faiths
                    </td>
                  </tr>
                  <tr>
                    <td>Other valid content</td>
                    <td>
                      Any other original, lawful content that follows this
                      policy
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          {/* 6. Format Requirements */}
            <h3>6. Format Requirements</h3>
            <p>
              Monetization is meant for posts that carry real content, so the
              following format rules apply:
            </p>
            <ul>
              <li>
                Text-only posts are not eligible. A post made only of text
                cannot be monetized.
              </li>
              <li>
                A plain photo is not eligible. A normal photo, selfie or picture
                that carries no informative or creative content does not
                qualify, even if the user took it.
              </li>
              <li>
                Original video or original media with real content is eligible.
                A video or media post the user created themselves qualifies only
                if it clearly delivers value in an eligible category, such as an
                informative video, an educational explainer, a comedy skit, a
                food recipe or an awareness message.
              </li>
              <li>
                Value must be visible. The post should clearly inform, teach,
                entertain or raise awareness. A post that only shows a face, a
                place or an object without any such content is not eligible.
              </li>
            </ul>

          {/* 7. Content Not Eligible for Monetization */}
            <h3>7. Content Not Eligible for Monetization</h3>
            <p>
              If a monetized post contains any of the following, it is not
              eligible and will not be paid.
            </p>
            <ul>
              <h4>Photos</h4>
              <li>
                A normal photo of the user, or of anyone else, with no
                informative or creative content
              </li>
              <li>Any other plain or ordinary photo</li>
              <li>
                A screenshot taken of someone else&apos;s post, chat, profile or
                content
              </li>
              <li>A photo copied from another person</li>
              <li>A photo taken from another social media platform</li>
              <li>Any photo protected by copyright</li>
              <li>
                Monetized post should not have any advertisement of yours and others business or any other financial benefits.
              </li>
            </ul>
            <ul>
              <h4>Videos</h4>
              <p>The same rules apply to videos:</p>
              <li>
                A plain video of the user or of anyone else with no informative
                or creative content
              </li>
              <li>
                A screen recording or screenshot-based video of someone
                else&apos;s content
              </li>
              <li>A video copied from another person</li>
              <li>
                A video downloaded, re-uploaded or reposted from another social
                media platform
              </li>
              <li>
                Any video protected by copyright, including movie clips, songs,
                TV content and stock content used without a licence
              </li>
              <li>
                Monetized post should not have any advertisement of yours and others business or any other financial benefits.
              </li>
            </ul>
            <ul>
              <h4>Text</h4>
              <li>
                Posts that contain only text and no original photo or video
                content
              </li>
              <li>
                Monetized post should not have any advertisement of yours and others business or any other financial benefits.
              </li>
            </ul>

          {/* 8. Consequences of a Violation */}
            <h3>8. Consequences of a Violation</h3>
            <p>If any post is found to contain content from Section 7:</p>
            <ul>
              <li>The payment for that post will not be made.</li>
              <li>The post will not be counted as a monetized post.</li>
            </ul>

          {/* 9. Additional Prohibited Content */}
            <h3>9. Additional Prohibited Content</h3>
            <p>The following content is also not eligible for monetization:</p>
            <ul>
              <li>Fake news, false or misleading information</li>
              <li>
                Content that spreads hatred, incites violence or insults any
                religion, caste, gender, region or language
              </li>
              <li>
                Abuse, threats, bullying or content that defames a person
              </li>
              <li>Adult, obscene or sexual content</li>
              <li>
                Violation of privacy, such as sharing personal details or phone
                numbers without permission
              </li>
              <li>Content that promotes illegal or dangerous activities</li>
              <li>
                Spam, clickbait, repeating the same post again and again, or
                fake views, likes and followers
              </li>
              <li>
                Copying another person&apos;s text, article or post
                (plagiarism)
              </li>
              <li>Content that puts the safety of children at risk</li>
              <li>
                AI-generated or edited content that is misleading or made to
                look real without being clearly disclosed
              </li>
            </ul>

          {/* 10. Special Rules for Political Content */}
            <h3>10. Special Rules for Political Content</h3>
            <ul>
              <li>
                False information meant to influence voters or elections is not
                allowed.
              </li>
              <li>
                Supporting or opposing a party or leader is allowed, but it must
                rest on facts and stay respectful.
              </li>
              <li>
                Fake quotes or false statements attributed to any person are not
                allowed.
              </li>
              <li>
                Lawful political content, as per the Constitution of India, is allowed. This includes the right to expression, right to speech, right to freedom, and right to work and travel.
              </li>
              <li>
                Political content must still follow Sections 6, 7 and 9 like
                every other category.
              </li>
            </ul>

          {/* 11. Review and Approval */}
            <h3>11. Review and Approval</h3>
            <ul>
              <li>
                Monetized posts may be reviewed by the Bharat Jagriti team.
              </li>
              <li>After review, a post may be approved or rejected.</li>
               {/* <li>Bharat Jagriti deserves the right to reject the approval of monetized post on the basis of the quality of the content.If Bharat Jagriti feels that the content is not worth user engagement and is made only with the intention of earning money than that content is useless for us and we may reject the monetization approval of that post.</li> */}
              <li>
                Payment is made only for approved posts that comply with this
                policy.
              </li>
              <li>
                At the time of payment approval, we will review all monetized
                posts. Only those posts that are valid and comply with our
                Monetization Policy will be eligible for payment. If any
                monetized post does not comply with our policy, the monetization
                amount earned from that post will be counted as zero, and no
                payment will be made for it.
              </li>
              <li>
                Monetized post should not have any advertisement of yours and others business or any other financial benefits. If this is found during the review, the entire amount earned from that monetized post will be counted as zero.
              </li>
              <li>
                If the company is not satisfied with the content of your
                monetized post, that monetized post will not be considered
                valid. The earnings generated from that monetized post will be
                counted as zero, and the company may also block or delete that
                monetized post.
              </li>
              <li>
                Monetization will be only paid to our permanent users.
                Discotinued users monetization will be on hold.
              </li>
            </ul>

          {/* 12. Action on Repeated Violations */}
            <h3>12. Action on Repeated Violations</h3>
            <ul>
              <li>First violation: a warning, and no payment for that post.</li>
              <li>
                Repeated violations: the monetization feature may be suspended
                for some time or permanently.
              </li>
              <li>
                Serious or illegal violations: stricter action may be taken
                against the account.
              </li>
            </ul>

          {/* 13. Complaints and Appeals */}
            <h3>13. Complaints and Appeals</h3>
            <p>
              If a user believes a post was rejected by mistake, the user can
              request a review through app support. The Bharat Jagriti team will
              re-check the post and share the final decision.
            </p>

          {/* 14. Changes to This Policy */}
            <h3>14. Changes to This Policy</h3>
            <p>
              Bharat Jagriti may update this policy when needed. Changes apply
              once they are published in the app.
            </p>

          {/* 15. User Consent */}
            <h3>15. User Consent</h3>
            <p>
              By turning on monetization and clicking “I Agree”, the user confirms that they have read this policy and will follow it.
            </p>
            </ul>
          </section>

          {/* 14. Revolution Module and Digital Signatures */}
          <section>
            <h1>14. Revolution Module and Digital Signatures</h1>
            <p>
              When you participate in a Revolution by providing your digital
              signature, your participation record is stored securely and linked
              to that Revolution. Please note:
            </p>
            <ul>
              <li>
                Revolution creators can download the list of supporting users
                and revolution content in PDF format.
              </li>
              <li>
                Other users can only see the total count of supporters — not
                individual names or identities.
              </li>
              <li>
                Your digital signature and participation record constitute a
                permanent civic record on the platform.
              </li>
              <li>
                Once you support a Revolution, this action cannot be reversed.
              </li>
            </ul>
          </section>

          {/* 15. Accessing This Privacy Policy In-App */}
          <section>
            <h1>15. Accessing This Privacy Policy In-App</h1>
            <p>
              As required by Google Play Store policy, this Privacy Policy is
              accessible directly within the Bharat Jagriti application. You can
              find it at:
            </p>
            <ul>
              <li>
                Registration/Sign-Up screen — a link is shown before you create
                your account
              </li>
              <li> Settings → Account Privacy → Privacy Policy</li>
              <li>App login screen footer</li>
              <li>Online at: https://www.bharatjagriti.com/privacy-policy</li>
            </ul>
          </section>

          {/* 16. Child Safety Standards Policy — CSAE & CSAM */}
          <section>
            <h1>
              16. Child Safety Standards Policy — CSAE &amp; CSAM (Google Play
              Compliance)
            </h1>
            <h2>Definitions</h2>
            <p>For the purposes of this policy:</p>
            <ul className="mt-2 mb-2">
              <li>
                CSAE (Child Sexual Abuse and Exploitation): Any content,
                behavior, communication, or activity that sexually exploits,
                abuses, or endangers a minor (any individual under the age of
                18).
              </li>
              <li>
                CSAM (Child Sexual Abuse Material): Any visual content (photos,
                videos, illustrations, or computer-generated imagery) that
                depicts a minor in a sexual manner.
              </li>
              <li>Minor: Any individual under the age of 18 years.</li>
              <li>
                Grooming: Any behavior by which an adult builds trust with a
                minor for the purpose of sexual exploitation or abuse.
              </li>
            </ul>
            <p>
              Bharat Jagriti is a social media platform listed on the Google
              Play Store and is required to comply with Google Play's Child
              Safety Standards Policy. We maintain a strict zero-tolerance
              policy against Child Sexual Abuse and Exploitation (CSAE) and
              Child Sexual Abuse Material (CSAM) in all forms.
            </p>
            <ul>
              <h2>16.1 Published Standards — Explicit Prohibition of CSAE</h2>
              <p>
                The following are strictly prohibited and will result in
                immediate permanent account termination:
              </p>
              <ul>
                <li>
                  Creating, uploading, sharing, storing, distributing,
                  accessing, or viewing CSAM
                </li>
                <li>
                  Any content that sexually depicts, exploits, or endangers
                  minors
                </li>
                <li>
                  Grooming (building trust with a minor for sexual exploitation
                  or abuse)
                </li>
                <li>
                  Soliciting personal information or explicit content from
                  minors
                </li>
                <li>Recruiting, luring, trafficking, or coercing minors</li>
                <li>
                  Sending unsolicited sexual or inappropriate content to minors
                </li>
                <li>
                  Facilitating real-world contact between adults and minors for
                  exploitative purposes
                </li>
                <li>
                  Any communication that promotes, glorifies, or trivialises
                  child sexual abuse
                </li>
              </ul>
              <p>
                Bharat Jagriti will take appropriate action, which may include
                reporting to the National Center for Missing &amp; Exploited
                Children (NCMEC), if we become aware of content with child
                sexual abuse materials. If you believe a child is in danger of
                or has been subject to abuse, exploitation, or trafficking,
                please contact your local law enforcement and a child safety
                organisation immediately.
              </p>
            </ul>
            <ul>
              <h2>16.2 In-App Reporting Mechanism</h2>
              <h3>SELF-CERTIFICATION:</h3>
              <p>
                Bharat Jagriti hereby self-certifies that Bharat Jagriti
                provides an in-app feedback and reporting mechanism that allows
                users to submit feedback, report concerns, or flag inappropriate
                content directly within the application. Users may access this
                feature via Settings → Support/ Help &amp; Feedback or through
                the report option available on content posts.
              </p>
              <ul>
                <li>
                  Report Button: Available on every post, comment, and profile
                  (⋯ → Report → Child Safety / CSAM)
                </li>
                <li>
                  Help &amp; Support Section: Profile → Help &amp; Support →
                  Report Child Safety Issue
                </li>
                <li>
                  Child Safety Email (linked in-app):
                  childsafety@bharatjagriti.com
                </li>
              </ul>
              <p>
                All reports are flagged as URGENT, reviewed within 24 hours,
                allow anonymous reporting, and require no proof to initiate
                investigation.
              </p>
            </ul>
            <ul>
              <h2>16.3 Action on CSAM</h2>
              <h3>SELF-CERTIFICATION:</h3>
              <p>
                Bharat Jagriti hereby self-certifies that we take appropriate
                and immediate action, including but not limited to removing
                CSAM, after obtaining actual knowledge of it, in full accordance
                with this published Child Safety Standards Policy and all
                applicable laws.
              </p>
              <ul>
                <h2>Detection Methods :</h2>
                <li>
                  PhotoDNA or equivalent hash-matching technology to identify
                  known CSAM
                </li>
                <li>AI/ML-based image and video content classifiers</li>
                <li>Keyword and metadata filters on uploaded content</li>
                <li>Behavioural analysis to detect grooming patterns</li>
                <li>
                  User reports reviewed by a dedicated Trust &amp; Safety team
                </li>
              </ul>
              <h2>Immediate Actions Upon Confirmed Knowledge of CSAM</h2>
              <p>
                Upon obtaining actual knowledge of CSAM on the platform, the
                following actions are taken without delay:
              </p>
              <ul>
                <li>
                  Content Removal: CSAM is immediately removed or disabled from
                  all public and private access within 24 hours
                </li>
                <li>
                  Account Suspension: The account responsible is suspended
                  immediately pending investigation
                </li>
                <li>
                  Evidence Preservation: All content, metadata, IP logs, and
                  account activity are securely preserved for law enforcement
                </li>
                <li>
                  Mandatory Reporting: CSAM is reported to NCMEC CyberTipline
                  and Indian law enforcement within 24 hours of confirmed
                  identification
                </li>
                <li>
                  Permanent Ban: Confirmed offending accounts are permanently
                  banned and device identifiers are blacklisted
                </li>
                <li>
                  Cooperation: Full cooperation is extended to law enforcement
                  agencies throughout the investigation
                </li>
              </ul>
            </ul>
            <ul>
              <h2>16.4 Legal Compliance &amp; Mandatory Reporting</h2>
              <h3>SELF-CERTIFICATION:</h3>
              <p>
                Bharat Jagriti hereby self-certifies that Bharat Jagriti
                complies with all applicable child safety laws and regulations,
                including having a process in place to report confirmed CSAM to
                the following authorities within 24 hours:
              </p>
              <ul>
                <li>
                  NCMEC CyberTipline: https://report.cybertip.org/reporting |
                  1-800-843-5678
                </li>
                <li>NCPCR Helpline: 1800-121-2830 | www.ncpcr.gov.in</li>
                <li>
                  National Cyber Crime Portal (India): https://cybercrime.gov.in
                  | 1930
                </li>
                <li>Local law enforcement under POCSO Act, 2012</li>
                <li>
                  POCSO e-Box (if applicable): https://pocsoebox.wcd.nic.in
                </li>
                <li>Childline India (24x7): Call 1098</li>
              </ul>
              <h2>Applicable Laws &amp; Regulations</h2>
              <p>
                Bharat Jagriti operates in full compliance with the following
                child safety laws and regulations:
              </p>
              <ul>
                <li>
                  The Protection of Children from Sexual Offences (POCSO) Act,
                  2012 — India's primary legislation protecting children from
                  sexual offences
                </li>
                <li>
                  The Information Technology (IT) Act, 2000 — including Section
                  67B which criminalises online child sexual abuse material
                </li>
                <li>
                  The Information Technology (Intermediary Guidelines and
                  Digital Media Ethics Code) Rules, 2021 — requiring prompt
                  removal of CSAM and reporting to law enforcement
                </li>
                <li>
                  The Indian Penal Code (IPC) — relevant sections on child
                  exploitation and trafficking
                </li>
                <li>
                  UN Convention on the Rights of the Child (UNCRC) —
                  international framework for child protection
                </li>
                <li>
                  Google Play Store Developer Program Policies — Child Safety
                  Standards for Social and Dating Apps
                </li>
              </ul>
              <h2>CSAM Reporting Process — Step by Step</h2>
              <p>
                Upon confirming the existence of CSAM on our platform, the
                following mandatory reporting process is followed:
              </p>
              <ul>
                <li>
                  Detection &amp; Confirmation: CSAM is identified through
                  automated detection or human review and confirmed by the Trust
                  &amp; Safety team
                </li>
                <li>
                  Evidence Secured: All content and associated data are
                  preserved securely before any removal
                </li>
                <li>
                  NCMEC CyberTipline Report: A report is filed at
                  www.cybertipline.org within 24 hours as mandated under
                  applicable law. The report includes: content details, account
                  information, IP address, timestamp, and device data
                </li>
                <li>
                  Indian Authority Notification: A simultaneous report is filed
                  with the National Commission for Protection of Child Rights
                  (NCPCR) and the Cyber Crime Cell of the relevant State Police
                </li>
                <li>
                  Content Removed: CSAM is removed from the platform after
                  evidence is preserved
                </li>
                <li>
                  Account Banned: The offending account is permanently
                  terminated
                </li>
                <li>
                  Law Enforcement Support: Complete cooperation is extended to
                  any law enforcement investigation that follows
                </li>
              </ul>
            </ul>
            <ul>
              <h2>16.5 Designated Child Safety Point of Contact</h2>
              <p>
                In compliance with Google Play Store's Child Safety Standards,
                Bharat Jagriti provides a designated Child Safety Point of
                Contact. This representative is authorised and equipped to:
              </p>
              <ul>
                <li>
                  Receive notifications from Google Play regarding CSAE content
                  found on the Bharat Jagriti platform
                </li>
                <li>Speak to our enforcement and content review procedures</li>
                <li>
                  Take immediate and appropriate action upon receiving such
                  notifications
                </li>
                <li>
                  Coordinate with law enforcement, Google Play, and regulatory
                  bodies on child safety matters
                </li>
                <li>
                  Escalate cases internally to the highest authorities and legal
                  team where required
                </li>
              </ul>
              <h2>Child Safety Point of Contact :</h2>
              <ul>
                <li>Organisation: GlowApps Private Limited</li>
                <li>App: Bharat Jagriti</li>
                <li>Officer Name: Bhaskar Bhushan</li>
                <li>Designated Role: CEO / Child Safety Officer</li>
                <li>Child Safety Email: childsafety@bharatjagriti.com</li>
                <li>CEO Email: ceo@bharatjagriti.com</li>
                <li>
                  Response Time Commitment: Within 24 hours of notification
                </li>
              </ul>
              <h2>Responsibilities of the Point of Contact</h2>
              <ul>
                <li>
                  Serve as the primary liaison between Google Play and Bharat
                  Jagriti on all CSAE matters
                </li>
                <li>
                  Monitor the designated email inbox daily for any Google Play
                  notifications regarding CSAE
                </li>
                <li>
                  Acknowledge all Google Play CSAE notifications within 24 hours
                </li>
                <li>
                  Initiate immediate internal review and enforcement action upon
                  receipt of any CSAE notification
                </li>
                <li>
                  Report back to Google Play on actions taken within 72 hours
                </li>
                <li>
                  Maintain records of all CSAE notifications and actions taken
                  for a minimum of 5 years
                </li>
                <li>
                  Ensure the Child Safety team is trained on enforcement
                  procedures and this policy
                </li>
              </ul>
            </ul>
            <ul>
              <h2>16.6 Age Verification &amp; Minor Protection</h2>
              <ul>
                <li>Age is mandatory during registration</li>
                <li>Users under 13 years are not permitted</li>
                <li>Accounts of underage users are suspended and deleted</li>
                <li>
                  Users aged 13–17 may have restricted access and are allowed
                  only under parental guidance
                </li>
                <li>
                  Additional age verification may be requested when necessary
                </li>
              </ul>
            </ul>
            <ul>
              <h2>16.7 Emergency Child Safety Resources</h2>
              <ul>
                <li>Childline India (24x7): Call 1098</li>
                <li>National Cyber Crime Portal: https://cybercrime.gov.in</li>
                <li>
                  NCMEC CyberTipline: https://report.cybertip.org/reporting
                </li>
                <li>POCSO e-Box: https://pocsoebox.wcd.nic.in</li>
                <li>Bharat Jagriti: ceo@bharatjagriti.com</li>
              </ul>
            </ul>
          </section>

          {/* 17. Inappropriate Content Policies */}
          <section>
            <h1>17. Inappropriate Content Policies</h1>

            {/* 17.1 Sexual Content and Profanity */}
            <ul>
              <h2>17.1 Sexual Content and Profanity</h2>
              <ol>
                <h3>1: Our Commitment to a Safe Platform</h3>
                <p>
                  Bharat Jagriti is designed to be a platform that connects,
                  informs, and inspires communities across India. We are
                  committed to ensuring that Bharat Jagriti does not become a
                  vehicle for harmful, exploitative, or sexually inappropriate
                  content. We believe in freedom of expression while firmly
                  upholding community safety, dignity, and respect.
                </p>
                <h3>2: PLATFORM DECLARATION</h3>
                <p>
                  Bharat Jagriti does not allow, promote, distribute, or
                  facilitate sexual content, pornography, profanity, sexually
                  predatory behaviour, non-consensual sexual content, or any
                  content that is sexually gratifying in nature. This policy is
                  absolute and applies to all users without exception.
                </p>
                <h3>3: Prohibited Sexual Content &amp; Profanity</h3>
                <p>
                  The following categories of content are strictly prohibited on
                  Bharat Jagriti and will result in immediate content removal
                  and account action:
                </p>
                <ul>
                  <h2>3.1 Pornography &amp; Sexually Explicit Material</h2>
                  <h3>STRICTLY PROHIBITED:</h3>
                  <p>
                    Bharat Jagriti does not allow any pornographic or sexually
                    explicit content of any kind, in any format — including
                    images, videos, audio, text, links, or embedded third-party
                    content.
                  </p>
                  <li>
                    Full or partial nudity presented in a sexual or gratuitous
                    manner
                  </li>
                  <li>Pornographic images, videos, GIFs, or animations</li>
                  <li>
                    Sexually explicit text descriptions, stories, or role-play
                  </li>
                  <li>Links or redirects to pornographic or adult websites</li>
                  <li>
                    Sexually explicit content disguised as art, satire, or
                    humour
                  </li>
                  <li>
                    AI-generated or digitally created sexually explicit content
                  </li>
                </ul>
                <ul>
                  <h3>3.2 Sexual Services &amp; Solicitation</h3>
                  <li>
                    Content that promotes, advertises, or facilitates
                    prostitution or escort services
                  </li>
                  <li>
                    Any content that solicits or offers sexual acts in exchange
                    for money, gifts, or compensation
                  </li>
                  <li>
                    Content that promotes sexual tourism or transactional sexual
                    relationships
                  </li>
                  <li>
                    Accounts created for the purpose of sexual solicitation or
                    sex work promotion
                  </li>
                  <li>
                    Suggestive messaging designed to lure users into sexual
                    service arrangements
                  </li>
                </ul>
                <ul>
                  <h3>3.3 Sexually Predatory Behaviour</h3>
                  <li>
                    Grooming behaviour targeting minors or vulnerable
                    individuals
                  </li>
                  <li>
                    Content designed to normalise or encourage sexual
                    exploitation
                  </li>
                  <li>
                    Unsolicited sharing of sexual content (cyber-flashing)
                  </li>
                  <li>
                    Repeated unwanted sexual advances, messages, or harassment
                  </li>
                  <li>
                    Content that glorifies or promotes sexual violence or
                    coercion
                  </li>
                </ul>
                <ul>
                  <h3>3.4 Non-Consensual Sexual Content</h3>
                  <li>
                    Sharing or distributing intimate images or videos of a
                    person without their consent ('revenge porn')
                  </li>
                  <li>
                    Threats to distribute intimate images as a form of coercion
                    or blackmail (sextortion)
                  </li>
                  <li>
                    Content that facilitates the non-consensual recording of
                    intimate acts
                  </li>
                  <li>
                    Re-sharing of intimate content originally distributed
                    without consent
                  </li>
                </ul>
                <ul>
                  <h3>3.5 Profanity &amp; Offensive Language</h3>
                  <li>
                    Excessive or gratuitous use of sexually explicit language
                  </li>
                  <li>
                    Content using profanity to harass, degrade, or sexually
                    demean other users
                  </li>
                  <li>
                    Sexually charged insults, slurs, or derogatory terms
                    targeting individuals or groups
                  </li>
                  <li>
                    Content combining profanity with imagery to create sexually
                    hostile environments
                  </li>
                </ul>
              </ol>
              <ul>
                <h2>4. Protection of Minors from Sexual Content</h2>
                <p>
                  The protection of users under 18 years of age from all forms
                  of sexual content is a top priority for Bharat Jagriti. We
                  implement the following measures to ensure minors are shielded
                  from any inappropriate material:
                </p>
                <h3>4.1 Age Verification</h3>
                <ul>
                  <li>
                    Users must provide their date of birth during registration
                  </li>
                  <li>
                    Users under 18 are automatically restricted from accessing
                    any age-restricted content
                  </li>
                  <li>
                    Accounts with suspicious age data are flagged for manual
                    review
                  </li>
                </ul>
                <h3>4.2 Minor-Specific Protections</h3>
                <ul>
                  <li>
                    Minors cannot receive direct messages from users they do not
                    follow
                  </li>
                  <li>Minors' accounts are set to private by default</li>
                  <li>
                    Mature or age-restricted content is completely hidden from
                    minor accounts regardless of settings
                  </li>
                  <li>
                    Any attempt by an adult to send sexual content to a minor
                    results in immediate account suspension and reporting to law
                    enforcement
                  </li>
                </ul>
                <h3>ABSOLUTE PROHIBITION:</h3>
                <p>
                  Under no circumstances does Bharat Jagriti permit any sexually
                  explicit, sexually suggestive, or sexually gratifying content
                  involving a person under the age of 18 years. Violations
                  result in immediate permanent ban and mandatory reporting to
                  law enforcement.
                </p>
              </ul>
            </ul>

            {/* 17.2 Hate Speech */}
            <ul>
              <h2>17.2 Hate Speech</h2>
              <ul>
                <h2>1. Overview</h2>
                <p>
                  Bharat Jagriti is a social media platform dedicated to
                  fostering respectful, inclusive, and constructive community
                  engagement. We believe in the free exchange of ideas while
                  maintaining firm boundaries against content that promotes
                  hatred, violence, or discrimination.
                </p>
                <p>
                  This policy sets out our position on hate speech and
                  discriminatory content, consistent with Google Play Store
                  policies and applicable laws in India and internationally.
                </p>
              </ul>
              <ul>
                <h3>2. Our Commitment Against Hate Speech</h3>
                <p>
                  Bharat Jagriti does not allow content that promotes violence
                  or incites hatred against individuals or groups based on any
                  protected characteristic.
                </p>
                <p>
                  We strictly prohibit any content — including posts, comments,
                  images, videos, audio, profile information, or any
                  user-generated material — that:
                </p>
                <ul>
                  <li>
                    Promotes, glorifies, or incites violence against any
                    individual or group
                  </li>
                  <li>Dehumanizes people based on protected characteristics</li>
                  <li>
                    Calls for discrimination against individuals or communities
                  </li>
                  <li>
                    Uses slurs, hate symbols, or degrading language targeting
                    protected groups
                  </li>
                  <li>
                    Spreads harmful stereotypes that degrade entire groups of
                    people
                  </li>
                  <li>
                    Threatens harm or harassment toward individuals based on who
                    they are
                  </li>
                </ul>
              </ul>
              <h3>3. Protected Characteristics</h3>
              <p>
                The following characteristics are protected under this policy.
                Content that targets, demeans, or incites hatred based on any of
                the following will be removed and may result in account
                suspension:
              </p>
              <ul>
                <h2>3.1 Identity &amp; Origin</h2>
                <ul>
                  <li>Race or Ethnic Origin</li>
                  <li>Nationality</li>
                  <li>Caste</li>
                  <li>Immigration Status</li>
                </ul>
              </ul>
              <ul>
                <h2>3.2 Belief &amp; Practice</h2>
                <p>
                  Religion (including all faiths and absence of religious
                  belief)
                </p>
              </ul>
              <ul>
                <h2>3.3 Personal Characteristics</h2>
                <ul>
                  <li>Age</li>
                  <li>Disability (physical or mental)</li>
                  <li>Veteran Status</li>
                </ul>
              </ul>
              <ul>
                <h2>3.4 Gender &amp; Sexuality</h2>
                <ul>
                  <li>Sexual Orientation</li>
                  <li>Gender</li>
                  <li>Gender Identity</li>
                </ul>
              </ul>
              <ul>
                <h2>3.5 Other Characteristics</h2>
                <p>
                  We also protect individuals from hatred based on any other
                  characteristic associated with systemic discrimination or
                  marginalization, even if not explicitly listed above.
                </p>
              </ul>
            </ul>

            {/* 17.3 Violence & Dangerous Activities */}
            <ul>
              <h2>17.3 Violence &amp; Dangerous Activities</h2>
              <ul>
                <h3>1. Overview</h3>
                <p>
                  Bharat Jagriti is a social media platform built for
                  meaningful, community-driven engagement. While we support
                  freedom of expression and open dialogue, Bharat Jagriti does
                  not allow content that depicts or facilitates gratuitous
                  violence or other dangerous activities that could result in
                  real-world harm to individuals or communities.
                </p>
                <p>
                  This policy explains exactly what is and is not allowed — and
                  how we enforce these standards — in full compliance with
                  Google Play Store's Violence Policy.
                </p>
              </ul>
              <ul>
                <h2>2. Core Policy Statement</h2>
                <p>
                  POLICY: Bharat Jagriti does not allow content that depicts or
                  facilitates gratuitous violence or other dangerous activities.
                  Content involving fictional violence in appropriate contexts —
                  such as news, education, sports, or creative works — is
                  generally permitted.
                </p>
                <p>
                  This policy applies to all user-generated content on the
                  platform, including but not limited to: posts, photos, videos,
                  reels, live streams, stories, comments, direct messages, and
                  profile information.
                </p>
              </ul>
              <ul>
                <h3>3. Quick Reference — Prohibited vs. Permitted</h3>
                <h4>PROHIBITED</h4>
                <ul>
                  <li>Real footage of assault or torture</li>
                  <li>Content glorifying bloodshed</li>
                  <li>Instructions for weapons or explosives</li>
                  <li>Dangerous viral challenge promotion</li>
                  <li>Threats against real individuals</li>
                  <li>Communal violence incitement</li>
                </ul>
                <h4>PERMITTED</h4>
                <ul>
                  <li>News reporting with journalistic context</li>
                  <li>Historical &amp; educational content</li>
                  <li>Combat sports highlights (legal)</li>
                  <li>Fictional / cinematic violence</li>
                  <li>Hunting, fishing &amp; wildlife content</li>
                  <li>Self-defence awareness (general)</li>
                </ul>
                <p>
                  Note: Context matters. The same content may be permitted or
                  prohibited depending on intent, framing, and audience. All
                  borderline content is subject to moderation review.
                </p>
              </ul>
              <ul>
                <h3>4. Prohibited Content — What Is Not Allowed</h3>
                <p>
                  The following categories of content are strictly prohibited on
                  Bharat Jagriti and will be removed upon detection or report:
                </p>
                <h4>4.1 Gratuitous &amp; Graphic Violence</h4>
                <ul>
                  <li>
                    Real-world footage or imagery of assault, murder, torture,
                    or abuse of persons or animals, shared for shock value or
                    entertainment
                  </li>
                  <li>
                    Graphic depictions of physical injury, gore, or death that
                    serve no clear educational or journalistic purpose
                  </li>
                  <li>
                    Content that glorifies, celebrates, or trivializes acts of
                    violence against any person or group
                  </li>
                  <li>
                    Videos or images of accidents or fatalities edited or shared
                    to sensationalize suffering
                  </li>
                </ul>
              </ul>
              <ul>
                <h3>4.2 Facilitation &amp; Incitement of Violence</h3>
                <ul>
                  <li>
                    Content that calls upon others to commit acts of physical
                    violence against individuals, communities, or institutions
                  </li>
                  <li>
                    Threats of violence directed at real, identifiable people or
                    groups
                  </li>
                  <li>
                    Instructions for making weapons, explosives, or tools
                    specifically intended to cause physical harm
                  </li>
                  <li>
                    Content used to coordinate, plan, or solicit participation
                    in violent acts
                  </li>
                </ul>
              </ul>
              <ul>
                <h3>4.3 Dangerous Activities &amp; Challenges</h3>
                <ul>
                  <li>
                    Promotion or encouragement of activities that pose a
                    serious, foreseeable risk of death or severe physical injury
                  </li>
                  <li>
                    Dangerous viral challenges or stunts that are explicitly
                    promoted for imitation by other users
                  </li>
                  <li>
                    Content instructing or encouraging self-harm or suicide
                  </li>
                  <li>
                    Unlicensed or illegal fighting, mob attacks, or vigilante
                    violence
                  </li>
                </ul>
              </ul>
              <ul>
                <h3>4.4 Violence Targeting Communities</h3>
                <ul>
                  <li>
                    Content that incites or celebrates communal violence,
                    religious conflict, or ethnic unrest
                  </li>
                  <li>
                    Posts designed to provoke physical violence between
                    communities, castes, or groups
                  </li>
                  <li>
                    Content dehumanizing any group to lay groundwork for
                    violence against them
                  </li>
                </ul>
              </ul>
              <h2>5. Permitted Content — What Is Generally Allowed</h2>
              <p>
                Bharat Jagriti recognizes that discussion and depiction of
                violence is sometimes necessary and valuable in appropriate
                contexts. The following categories are generally allowed:
              </p>
              <ul>
                <h2>5.1 News, Journalism &amp; Public Interest Reporting</h2>
                <ul>
                  <li>
                    Factual reporting on violent events, crimes, conflicts, or
                    disasters by credible journalists and news sources
                  </li>
                  <li>
                    Documentary-style coverage of wars, civil unrest, or
                    security incidents presented without glorification
                  </li>
                  <li>
                    Content raising awareness about the consequences of
                    violence, such as anti-violence campaigns or victim advocacy
                  </li>
                  <li>
                    Graphic footage shared in a news context must include a
                    content warning and must not be edited to sensationalize
                    violence
                  </li>
                </ul>
              </ul>
              <ul>
                <h2>5.2 Educational, Historical &amp; Research Content</h2>
                <ul>
                  <li>
                    Historical accounts of wars, conflicts, and atrocities
                    shared with educational intent
                  </li>
                  <li>
                    Academic or research-oriented content about the causes and
                    consequences of violence
                  </li>
                  <li>
                    Content about violence prevention, conflict resolution, or
                    human rights
                  </li>
                  <li>
                    Educational intent must be evident from the framing,
                    context, and presentation of the content
                  </li>
                </ul>
              </ul>
              <ul>
                <h2>5.3 Artistic, Fictional &amp; Creative Content</h2>
                <ul>
                  <li>
                    Fictional depictions of violence in clearly creative works
                    such as stories, scripts, film criticism, or illustrated art
                  </li>
                  <li>
                    Satirical or clearly fictional portrayals of violence that
                    do not target real, identifiable individuals
                  </li>
                  <li>
                    Violence depicted in folklore, mythology, or traditional
                    cultural storytelling
                  </li>
                  <li>
                    Fictional content must not be used as a cover to distribute
                    actual harmful instructions or real violent footage
                  </li>
                </ul>
              </ul>
              <ul>
                <h2>5.4 Sports, Games &amp; Competitive Activities</h2>
                <ul>
                  <li>
                    Coverage of legal combat sports such as boxing, wrestling,
                    kabaddi, MMA, and other sanctioned contact sports
                  </li>
                  <li>
                    Highlight clips, match replays, and commentary from
                    professional sporting events
                  </li>
                  <li>
                    Content related to lawful hunting, fishing, or wildlife
                    management activities
                  </li>
                  <li>
                    Reviews, gameplay, and discussion of video games or animated
                    content that depict fictional violence in a game context —
                    such as cartoons, action games, or adventure games — are
                    generally permitted
                  </li>
                  <li>
                    Content must not promote poaching, illegal animal cruelty,
                    or unlicensed weapon use
                  </li>
                </ul>
              </ul>
              <ul>
                <h2>5.5 Self-Defence &amp; Safety Awareness</h2>
                <ul>
                  <li>
                    General educational content on personal safety and security
                    awareness
                  </li>
                  <li>
                    Self-defence guidance from licensed or qualified
                    professionals within a clearly educational framing
                  </li>
                  <li>
                    This does not extend to instructions for building weapons or
                    facilitating harm
                  </li>
                </ul>
              </ul>
              <ul>
                <h2>
                  6. Sensitive Content — Age Restrictions &amp; Content Warnings
                </h2>
                <p>
                  Certain content that is not outright prohibited may still be
                  considered sensitive and inappropriate for all audiences.
                  Bharat Jagriti reserves the right to:
                </p>
                <ul>
                  <li>
                    Apply content warnings or age-gate access to graphic or
                    disturbing content, even when it serves a legitimate purpose
                  </li>
                  <li>
                    Reduce the algorithmic distribution of violent content that,
                    while not prohibited, is deemed unsuitable for general
                    audiences
                  </li>
                  <li>
                    Require users to confirm they are 18 or older before
                    accessing certain restricted content categories
                  </li>
                </ul>
              </ul>
              <ul>
                <h2>7. User Responsibilities</h2>
                <p>
                  All users of Bharat Jagriti are expected to uphold this
                  policy. By using the platform, you agree that you will not:
                </p>
                <ul>
                  <li>
                    Post, share, or distribute any content that violates this
                    Violence Policy
                  </li>
                  <li>
                    Use the platform to threaten, intimidate, or incite violence
                    against others
                  </li>
                  <li>
                    Re-share violent content that was originally posted in
                    violation of this policy
                  </li>
                  <li>
                    Misuse permitted content categories — such as 'news' or
                    'education' — as a cover for sharing gratuitous violent
                    content
                  </li>
                  <li>
                    Encourage or pressure other users to view or share violent
                    content
                  </li>
                </ul>
              </ul>
              <ul>
                <h2>8. Moderation &amp; Enforcement</h2>
                <ul>
                  <h3>8.1 How We Detect Violations</h3>
                  <p>
                    Bharat Jagriti uses a combination of automated tools and
                    human review to detect content that may violate this policy.
                    Our moderation systems review content flagged by users,
                    detected by our automated filters, and identified through
                    proactive monitoring.
                  </p>
                </ul>
                <ul>
                  <h3>8.2 Content-Level Actions</h3>
                  <ul>
                    <li>
                      Immediate removal of content that violates this policy
                    </li>
                    <li>
                      Addition of a content warning label or visibility
                      restriction for borderline content
                    </li>
                    <li>Reduction of content reach in algorithmic feeds</li>
                  </ul>
                </ul>
                <ul>
                  <h3>8.3 Account-Level Actions</h3>
                  <ul>
                    <li>
                      Formal written warning issued to the account holder for a
                      first or minor violation
                    </li>
                    <li>
                      Temporary suspension of posting privileges or account
                      access
                    </li>
                    <li>
                      Permanent account ban for severe, repeated, or egregious
                      violations
                    </li>
                    <li>
                      Referral to Indian law enforcement where content involves
                      credible threats or criminal activity
                    </li>
                  </ul>
                </ul>
                <ul>
                  <h3>8.4 Appeals</h3>
                  <p>
                    If you believe your content was removed or your account was
                    actioned in error, you may appeal the decision by contacting
                    us at ceo@bharatjagriti.com. We aim to review and respond to
                    all appeals within 7 working days. During the appeal review,
                    the content will remain removed.
                  </p>
                </ul>
                <ul>
                  <h3>9. How to Report Violent Content</h3>
                  <p>
                    We rely on our community to help keep Bharat Jagriti safe.
                    If you encounter content that violates this policy, please
                    use the in-app Report feature available on every post, reel,
                    comment, profile, and live stream.
                  </p>
                  <p>
                    For content that involves an imminent and credible threat to
                    someone's life or safety, please also contact your local
                    police immediately or dial the national emergency number
                    112.
                  </p>
                  <p>
                    All reports are reviewed by our moderation team and treated
                    with strict confidentiality. We do not reveal the identity
                    of users who submit reports, and we do not tolerate
                    retaliation against good-faith reporters.
                  </p>
                </ul>
                <ul>
                  <h3>10. Legal Compliance</h3>
                  <p>
                    This policy is designed to comply with the following laws
                    and regulations:
                  </p>
                  <ul>
                    <li>Google Play Developer Program Policies — Violence</li>
                    <li>
                      Information Technology (Intermediary Guidelines and
                      Digital Media Ethics Code) Rules, 2021
                    </li>
                    <li>
                      Information Technology Act, 2000 and the IT (Amendment)
                      Act, 2008
                    </li>
                    <li>
                      Indian Penal Code (IPC) — provisions on incitement,
                      threats, and public order
                    </li>
                    <li>
                      Cable Television Networks (Regulation) Act, 1995 —
                      programme code standards
                    </li>
                    <li>
                      Applicable international standards on online safety and
                      harmful digital content
                    </li>
                  </ul>
                  <p>
                    We cooperate fully with Indian law enforcement agencies.
                    Where required by a valid legal order or to prevent imminent
                    harm to a person, we will disclose relevant user information
                    to the appropriate authorities.
                  </p>
                </ul>
              </ul>
            </ul>

            {/* 17.4 Violent Extremism & Terrorism */}
            <ul>
              <h2>17.4 Violent Extremism &amp; Terrorism</h2>
              <ul>
                <h2>1. Overview</h2>
                <p>
                  Bharat Jagriti is a social media platform committed to the
                  safety, unity, and well-being of every Indian citizen and
                  every member of our global community. We believe in open
                  expression and robust public debate — but we draw an absolute,
                  non-negotiable line at content that promotes, facilitates, or
                  glorifies terrorism, violent extremism, or organised violence
                  against civilians.
                </p>
                <p>
                  This policy sets out our position on violent extremist content
                  in full alignment with Google Play Store's Violent Extremism
                  Policy, Indian law, and our own platform values.
                </p>
              </ul>
              <ul>
                <h2>2. Zero-Tolerance Commitment</h2>
                <p>
                  Bharat Jagriti maintains a zero-tolerance policy toward
                  terrorist organisations, violent extremist movements, and any
                  content that promotes, plans, glorifies, or facilitates
                  violence against civilians.
                </p>
                <p>
                  No individual, group, organisation, or movement that has
                  engaged in, prepared for, claimed responsibility for, or
                  threatened acts of terror or mass violence may use Bharat
                  Jagriti for any purpose — including recruitment, fundraising,
                  propaganda, communication, or any form of outreach.
                </p>
              </ul>
              <ul>
                <h2>3. Organisations &amp; Movements Covered</h2>
                <p>
                  This policy applies to, but is not limited to, the following
                  categories of individuals, groups, and organisations:
                </p>
                <ul>
                  <h3>3.1 Designated Terrorist Organisations</h3>
                  <ul>
                    <li>
                      Organisations listed as terrorist entities under the
                      Unlawful Activities (Prevention) Act, 1967 (UAPA), India
                    </li>
                    <li>
                      Organisations designated as terrorist entities by the
                      United Nations Security Council
                    </li>
                    <li>
                      Entities listed on the US Department of State's Foreign
                      Terrorist Organization (FTO) list or equivalent lists of
                      other countries
                    </li>
                    <li>
                      Any group that has carried out, claimed, or attempted acts
                      of terrorism, mass violence, or genocide
                    </li>
                  </ul>
                </ul>
                <ul className="mt-3">
                  <h3>3.2 Violent Extremist Movements</h3>
                  <ul>
                    <li>
                      Ideological movements — religious, political,
                      ethno-nationalist, or otherwise — that advocate or promote
                      mass violence against civilians
                    </li>
                    <li>
                      White supremacist, neo-Nazi, jihadist, separatist, or
                      other extremist movements with a documented history of
                      violence
                    </li>
                    <li>
                      Vigilante groups, militia movements, or non-state armed
                      groups engaged in organised violence
                    </li>
                  </ul>
                </ul>
                <ul className="mt-3">
                  <h3>3.3 Individuals Acting on Behalf of Such Groups</h3>
                  <ul>
                    <li>
                      Individuals acting as recruiters, propagandists,
                      financiers, or facilitators for any of the above
                      organisations
                    </li>
                    <li>
                      Users who openly identify with or pledge allegiance to
                      violent extremist organisations
                    </li>
                  </ul>
                </ul>
                <ul className="mt-3">
                  <h3>4. Prohibited Content</h3>
                  <p>
                    The following categories of content are strictly prohibited
                    on Bharat Jagriti under this policy:
                  </p>
                  <ul>
                    <h3>4.1 Promotion &amp; Propaganda</h3>
                    <ul>
                      <li>
                        Content that promotes, advertises, or endorses terrorist
                        organisations, violent extremist groups, or their
                        ideologies
                      </li>
                      <li>
                        Manifestos, statements, or publications issued by
                        terrorist or violent extremist groups
                      </li>
                      <li>
                        Content that presents terrorist or extremist groups in a
                        positive, heroic, or admirable light
                      </li>
                      <li>
                        Symbols, logos, flags, slogans, or insignia associated
                        with designated terrorist or violent extremist
                        organisations
                      </li>
                    </ul>
                  </ul>
                  <ul className="mt-2">
                    <h3>4.3 Planning &amp; Facilitation of Violence</h3>
                    <ul>
                      <li>
                        Content that plans, coordinates, or provides operational
                        support for acts of terrorism or mass violence
                      </li>
                      <li>
                        Instructions, guides, or tutorials that facilitate the
                        carrying out of terrorist acts
                      </li>
                      <li>
                        Content that identifies, targets, or threatens specific
                        individuals or locations for violent attack
                      </li>
                      <li>
                        Fundraising appeals, financial transactions, or
                        solicitations on behalf of violent extremist
                        organisations
                      </li>
                    </ul>
                  </ul>
                  <ul className="mt-2">
                    <h3>4.4 Glorification &amp; Celebration</h3>
                    <ul>
                      <li>
                        Content that glorifies, celebrates, or commemorates
                        terrorist attacks, mass shootings, genocide, or other
                        acts of mass civilian violence
                      </li>
                      <li>
                        Tributes, memorials, or praise directed at perpetrators
                        of terrorist acts or mass violence
                      </li>
                      <li>
                        Content that portrays victims of terrorism in a
                        dehumanising or mocking manner
                      </li>
                      <li>
                        Anniversary posts, countdowns, or content that frames
                        terrorist events as achievements or victories
                      </li>
                    </ul>
                  </ul>
                  <ul className="mt-2">
                    <h3>4.5 Incitement to Violence</h3>
                    <ul>
                      <li>
                        Content that directly or indirectly calls on others to
                        commit acts of terrorism, communal violence, or mass
                        harm
                      </li>
                      <li>
                        Content that frames specific communities, groups, or
                        individuals as enemies deserving of violent retribution
                      </li>
                      <li>
                        Disinformation or fabricated content deliberately
                        crafted to incite mob violence or communal unrest
                      </li>
                    </ul>
                  </ul>
                </ul>
                <ul className="mt-3">
                  <h3>
                    5. Permitted Content — Education, Research &amp; Awareness
                  </h3>
                  <p>
                    We understand that the responsible discussion of terrorism
                    and extremism is essential for education, journalism,
                    counter-extremism work, and public policy. The following
                    types of content are generally permitted, provided they do
                    not serve to promote or facilitate violence:
                  </p>
                  <ul className="mt-2">
                    <h2>5.1 Educational &amp; Academic Content</h2>
                    <ul>
                      <li>
                        Academic research, analysis, and scholarship on
                        terrorism, radicalisation, and violent extremism
                      </li>
                      <li>
                        Educational content explaining the history, ideology,
                        and impact of terrorist movements for the purpose of
                        awareness and prevention
                      </li>
                      <li>
                        Policy discussions and debates on counter-terrorism
                        strategies and national security
                      </li>
                    </ul>
                  </ul>
                  <ul className="mt-2">
                    <h2>5.2 News &amp; Journalism</h2>
                    <ul>
                      <li>
                        Factual news reporting on terrorist attacks, extremist
                        movements, and related events
                      </li>
                      <li>
                        Investigative journalism that exposes extremist
                        networks, financing, or operations
                      </li>
                      <li>
                        Commentary and opinion pieces that critically analyse
                        terrorism and extremism without promoting them
                      </li>
                    </ul>
                    <p>
                      Important: News and journalistic content must not be
                      edited, cropped, or presented in a way that removes
                      critical context and inadvertently promotes or glorifies
                      the violent acts being reported on.
                    </p>
                  </ul>
                  <ul className="mt-2">
                    <h2>5.3 Counter-Extremism &amp; Prevention</h2>
                    <ul>
                      <li>
                        Content produced by counter-terrorism organisations,
                        NGOs, or government bodies to raise awareness and
                        prevent radicalisation
                      </li>
                      <li>
                        Personal testimonies from former extremists, survivors,
                        or affected communities shared to discourage
                        radicalisation
                      </li>
                      <li>
                        Content that challenges extremist narratives,
                        deconstructs propaganda, or promotes peace and
                        reconciliation
                      </li>
                    </ul>
                  </ul>
                  <ul className="mt-2">
                    <h2>5.4 Artistic &amp; Documentary Works</h2>
                    <ul>
                      <li>
                        Films, documentaries, literature, or art that critically
                        engage with the themes of terrorism and extremism
                      </li>
                      <li>
                        Historical and cultural content that examines the roots,
                        consequences, and human cost of violent extremism
                      </li>
                    </ul>
                    <p>
                      Note: Artistic content must not romanticise or sanitise
                      terrorist acts or their perpetrators, even in a fictional
                      framing.
                    </p>
                  </ul>
                </ul>
                <ul className="mt-3">
                  <h3>6. Context &amp; Intent</h3>
                  <p>
                    Bharat Jagriti uses a combination of automated detection
                    systems, human moderation review, and community reports to
                    evaluate potentially violating content. When reviewing
                    content, our moderation team will consider:
                  </p>
                  <ul>
                    <li>
                      The intent and purpose of the content — whether it
                      promotes or counters extremist ideology
                    </li>
                    <li>
                      The full context in which words, images, or symbols appear
                    </li>
                    <li>
                      Whether the content provides genuine educational,
                      journalistic, or counter-narrative value
                    </li>
                    <li>
                      Whether the content could reasonably serve as recruitment
                      or propaganda material, regardless of stated intent
                    </li>
                  </ul>
                  <p>
                    Context does not override clear violations. Content that
                    explicitly promotes violence, recruits for terrorist
                    organisations, or celebrates terrorist attacks will be
                    removed regardless of any claimed educational or artistic
                    framing.
                  </p>
                </ul>
                <ul className="mt-3">
                  <h3>7. User Responsibilities</h3>
                  <p>
                    By using Bharat Jagriti, every user agrees that they will
                    not:
                  </p>
                  <ul>
                    <li>
                      Post, share, or distribute any content that violates this
                      Violent Extremism Policy
                    </li>
                    <li>
                      Use the platform to recruit, radicalise, or fundraise on
                      behalf of any terrorist or violent extremist organisation
                    </li>
                    <li>
                      Share links, referrals, or instructions that direct others
                      to extremist platforms or content
                    </li>
                    <li>
                      Misrepresent prohibited content as educational or artistic
                      to circumvent this policy
                    </li>
                    <li>
                      Engage in targeted harassment of other users based on
                      perceived sympathies with any ideology
                    </li>
                  </ul>
                </ul>
                <ul className="mt-3">
                  <h3>8. Enforcement</h3>
                  <ul>
                    <h3>8.1 Content-Level Actions</h3>
                    <ul>
                      <li>
                        Immediate removal of content found to be in violation of
                        this policy
                      </li>
                      <li>
                        Suppression of content pending review where a violation
                        is suspected but requires investigation
                      </li>
                      <li>
                        Permanent removal of content confirmed to promote, plan,
                        or glorify violent extremism
                      </li>
                    </ul>
                  </ul>
                  <ul>
                    <h3>8.2 Account-Level Actions</h3>
                    <ul>
                      <li>
                        Immediate and permanent suspension of accounts operated
                        by or on behalf of designated terrorist organisations
                      </li>
                      <li>
                        Permanent ban of accounts found to be recruiting,
                        fundraising, or publishing propaganda for violent
                        extremist groups
                      </li>
                      <li>
                        Temporary suspension and formal warning for first-time
                        or ambiguous violations pending review
                      </li>
                      <li>
                        Referral of account information to Indian law
                        enforcement or national security agencies where legally
                        required or where imminent harm is suspected
                      </li>
                    </ul>
                  </ul>
                  <ul>
                    <h3>8.3 Platform-Level Cooperation</h3>
                    <ul>
                      <li>
                        Cooperation with the Ministry of Home Affairs, National
                        Investigation Agency (NIA), and other relevant Indian
                        authorities
                      </li>
                      <li>
                        Compliance with lawful orders under the UAPA,
                        Information Technology Act, and other applicable
                        legislation
                      </li>
                      <li>
                        Participation in cross-platform reporting initiatives to
                        combat the spread of violent extremist content
                      </li>
                    </ul>
                  </ul>
                  <ul>
                    <h3>8.4 Appeals</h3>
                    <ul>
                      <p>
                        Users who believe their content was removed or their
                        account was actioned in error may appeal by contacting
                        us at ceo@bharatjagriti.com. Appeals relating to violent
                        extremism will be reviewed within 3 working days.
                        Accounts associated with designated terrorist
                        organisations are not eligible for appeal.
                      </p>
                    </ul>
                  </ul>
                </ul>
                <ul className="mt-3">
                  <h2>9. Reporting Extremist Content</h2>
                  <p>
                    If you encounter content on Bharat Jagriti that you believe
                    promotes, glorifies, or facilitates violent extremism or
                    terrorism, please report it immediately using the in-app
                    Report feature available on every post, profile, comment,
                    and live stream.
                  </p>
                  <p>
                    All reports are treated with strict confidentiality.
                    Reporters will not be identified to the subject of the
                    report under any circumstances. We do not tolerate
                    intimidation or retaliation against users who make
                    good-faith reports.
                  </p>
                  <p>
                    For urgent matters involving an imminent threat to life or
                    national security, please also contact your local police or
                    the National Emergency Number (112) immediately.
                  </p>
                </ul>
                <ul className="mt-3">
                  <h2>10. Legal Compliance</h2>
                  <p>
                    This policy has been developed in alignment with the
                    following laws and regulations:
                  </p>
                  <ul>
                    <li>
                      Google Play Developer Program Policies — Violent Extremism
                    </li>
                    <li>
                      Unlawful Activities (Prevention) Act, 1967 (UAPA), India —
                      as amended
                    </li>
                    <li>
                      Information Technology (Intermediary Guidelines and
                      Digital Media Ethics Code) Rules, 2021
                    </li>
                    <li>
                      Indian Penal Code — Sections on sedition, public nuisance,
                      and promoting enmity
                    </li>
                    <li>
                      United Nations Security Council Resolutions on
                      Counter-Terrorism
                    </li>
                    <li>
                      Financial Action Task Force (FATF) guidelines on terrorist
                      financing
                    </li>
                  </ul>
                  <p>
                    Bharat Jagriti will fully cooperate with Indian law
                    enforcement, the NIA, and international law enforcement
                    agencies in investigations related to terrorism and violent
                    extremism. We will disclose user data when required by a
                    valid legal order, consistent with our Privacy Policy.
                  </p>
                </ul>
              </ul>
            </ul>

            {/* 17.5 Sensitive Events Policy */}
            <ul>
              <h2>17.5 Sensitive Events Policy</h2>
              <ul className="mt-2">
                <h3>1. Overview</h3>
                <h3>
                  Compliance with Google Play Sensitive Events Requirements
                </h3>
                <p>
                  Bharat Jagriti acknowledges that our platform may surface
                  content relating to civil emergencies, natural disasters,
                  public health emergencies, conflicts, deaths, or other events
                  of significant social, cultural, or political impact
                  (collectively "Sensitive Events"). We are committed to
                  handling such content responsibly and in full compliance with
                  Google Play's Sensitive Events policy.
                </p>
              </ul>
              <ul className="mt-3">
                <h3>2. What We Do Not Permit</h3>
                <p>
                  The following uses of Sensitive Event content are strictly
                  prohibited on Bharat Jagriti:
                </p>

                <ul>
                  <li>
                    The following uses of Sensitive Event content are strictly
                    prohibited on Bharat Jagriti:
                  </li>
                  <li>
                    Capitalising on, monetising, or commercialising tragedy,
                    death, or disaster without appropriate context
                  </li>
                  <li>
                    Publishing content that is insensitive, exploitative, or
                    disrespectful toward victims, affected communities, or their
                    families
                  </li>
                  <li>
                    Spreading unverified misinformation or disinformation about
                    an ongoing sensitive event
                  </li>
                  <li>
                    Using images, videos, or personal details of victims to
                    generate engagement, advertising revenue, or viral content
                  </li>
                  <li>
                    Organising or promoting activities that exploit a sensitive
                    event for financial or political gain
                  </li>
                </ul>
              </ul>
              <ul className="mt-3">
                <h3>3. What We Permit</h3>
                <p>
                  Content related to Sensitive Events is generally allowed on
                  Bharat Jagriti when it meets the EDSA standard — that is, when
                  it serves Educational, Documentary, Scientific, or Artistic
                  purposes, or when it is intended to:
                </p>
                <ul>
                  <li>
                    Alert users to an active emergency, natural disaster, or
                    public health threat
                  </li>
                  <li>
                    Raise community awareness, facilitate relief coordination,
                    or disseminate official safety guidance
                  </li>
                  <li>
                    Document events for historical or journalistic record in a
                    factual and respectful manner
                  </li>
                  <li>
                    Promote empathy, civic solidarity, and constructive
                    community responses
                  </li>
                  <li>
                    Support verified non-governmental organisations or
                    government disaster-relief operations
                  </li>
                </ul>
              </ul>
              <ul className="mt-3">
                <h3>4. How We Enforce This Policy</h3>
                <ul>
                  <li>
                    Our Trust &amp; Safety team uses a combination of automated
                    detection and human review to identify and act upon
                    Sensitive Event-related content that violates this policy
                  </li>
                  <li>
                    We partner with authoritative sources — including Government
                    of India agencies, state disaster management authorities,
                    and WHO India — to verify emergency-related information
                    before amplification
                  </li>
                  <li>
                    Users may report content they believe violates this policy
                    through the in-app reporting feature. Reports are reviewed
                    within 24 hours during active sensitive events
                  </li>
                  <li>
                    Verified violations may result in content removal, account
                    suspension, or permanent ban, depending on severity
                  </li>
                </ul>
              </ul>
              <ul className="mt-3">
                <h3>5. Your Data During Sensitive Events</h3>
                <p>
                  During declared emergencies or public health crises, we may
                  share aggregated, anonymised location or usage data with
                  Government of India agencies or state authorities solely to
                  assist with relief coordination and public safety. We will
                  never share personally identifiable information without your
                  explicit consent or a valid legal order.
                </p>
              </ul>
            </ul>

            {/* 17.6 Bullying and Harassment Policy */}
            <ul>
              <h2>17.6 Bullying and Harassment Policy</h2>
              <h3>
                Compliance with Google Play Bullying and Harassment Requirements
              </h3>
              <p>
                Bharat Jagriti is firmly committed to ensuring that our platform
                does not contain or facilitate threats, harassment, or bullying
                of any kind. This commitment is embedded in our product design,
                moderation systems, and data practices as described below.
                prohibited.
              </p>
              <ul className="mt-2">
                <h2>1. Prohibited Conduct</h2>
                <p>
                  The following behaviours are strictly prohibited on Bharat
                  Jagriti and will result in content removal, account
                  suspension, or permanent ban:
                </p>
                <ul>
                  <li>
                    Posting, sharing, or facilitating content that threatens
                    physical harm, violence, or property damage against any
                    individual or group
                  </li>
                  <li>
                    Repeatedly contacting, following, messaging, or tagging a
                    user in an unwanted and intimidating manner (cyberstalking)
                  </li>
                  <li>
                    Publishing private or personally identifiable information of
                    another person without their consent for the purpose of
                    humiliating or harming them (doxxing)
                  </li>
                  <li>
                    Creating fake accounts or impersonating another person to
                    harass, deceive, or damage their reputation
                  </li>
                  <li>
                    Coordinating or inciting group harassment campaigns
                    ("pile-ons") against an individual or organisation
                  </li>
                  <li>
                    Posting content intended to demean, degrade, shame, or
                    humiliate a specific person based on their appearance,
                    identity, beliefs, or personal circumstances
                  </li>
                  <li>
                    Sending threatening, abusive, or repeatedly unwanted direct
                    messages
                  </li>
                  <li>
                    Using comments, tags, or mentions to intimidate, belittle,
                    or target another user
                  </li>
                  <li>
                    Sharing manipulated or deceptive content (including
                    deepfakes) designed to harm an individual's dignity or
                    reputation
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h2>2. Platform Design Commitments</h2>
                <p>
                  To prevent our App from facilitating bullying or harassment,
                  we have implemented the following safeguards:
                </p>
                <ul>
                  <li>
                    Block and Mute Controls: Every user can instantly block or
                    mute any other account, preventing all further contact and
                    content visibility
                  </li>
                  <li>
                    Comment Filters: Automated keyword and phrase filters
                    identify and hold potentially harassing comments for human
                    review before they are publicly displayed
                  </li>
                  <li>
                    DM Restrictions: Direct messaging is restricted to mutual
                    followers by default. Users can choose to restrict messages
                    further in Messages → Block
                  </li>
                  <li>
                    Restricted Mentions: Users can limit who may tag or mention
                    them in posts and comments
                  </li>
                  <li>
                    Safe Mode: Minor users (under 18) are automatically enrolled
                    in Safe Mode, which applies additional content filters and
                    restricts unsolicited messages
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h2>3. Reporting Mechanism</h2>
                <p>
                  We provide accessible, in-app tools so that any user can
                  report bullying or harassing content immediately:
                </p>
                <ul>
                  <li>
                    Tap the three-dot menu on any post, comment, or profile and
                    select "Report"
                  </li>
                  <li>
                    Select the relevant category: Harassment, Threats, Bullying,
                    Doxxing, Impersonation, or Other
                  </li>
                  <li>
                    Optionally provide additional context or attach screenshots
                    to support your report
                  </li>
                  <li>
                    Your identity as a reporter is kept strictly confidential
                    and will not be disclosed to the reported user
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h2>4. Review and Enforcement</h2>
                <ul>
                  <li>
                    Reports are acknowledged instantly with a confirmation
                    notification
                  </li>
                  <li>
                    Our Trust &amp; Safety team reviews reported content within
                    24 hours (priority cases involving threats of physical
                    violence are escalated within 2 hours)
                  </li>
                  <li>
                    Enforcement actions include: content removal, temporary
                    suspension, permanent account termination, and referral to
                    law enforcement where applicable under Indian law
                  </li>
                  <li>
                    The reporting user receives a notification once the review
                    is complete, subject to confidentiality constraints
                  </li>
                  <li>
                    Users whose content is actioned may appeal the decision
                    within 14 days via Support → Admin Contacts
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h2>5. Data Handling in Harassment Cases</h2>
                <p>
                  Information collected during a harassment or bullying
                  investigation (including reported content, account metadata,
                  and communication logs) is:
                </p>
                <ul>
                  <li>
                    Retained for a minimum of 90 days to support ongoing
                    investigations and potential legal proceedings
                  </li>
                  <li>
                    Accessible only to authorised Trust &amp; Safety personnel
                    on a need-to-know basis
                  </li>
                  <li>
                    Shared with Indian law enforcement or judicial authorities
                    only in response to a valid legal order or where there is an
                    imminent risk to life
                  </li>
                  <li>
                    Never sold or disclosed to third parties for commercial
                    purposes
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h2>6. Zero-Tolerance for Repeat Offenders</h2>
                <p>
                  Users who receive two or more confirmed violations of this
                  policy within any 180-day period will face permanent account
                  termination with no right to re-register. Device-level and
                  IP-level restrictions may also be applied to prevent evasion.
                </p>
              </ul>
            </ul>

            {/* 17.7 Dangerous Products Policy */}
            <ul>
              <h2>17.7 Dangerous Products Policy</h2>
              <h3>
                Compliance with Google Play Dangerous Products Requirements
              </h3>
              <p>
                Bharat Jagriti does not facilitate, enable, or allow the sale
                of, instructions for, or illegal modification of any dangerous
                product. This policy is strictly enforced across all content
                types on our platform, including posts, comments, stories,
                videos, direct messages, and links to external websites.
              </p>
              <ul className="mt-2">
                <h3>1. Absolutely Prohibited Content</h3>
                <p>
                  The following content is strictly prohibited on Bharat Jagriti
                  and will result in immediate removal and account action:
                </p>
                <h3>Sale and Commercial Facilitation</h3>
                <ul className="mt-2 mb-2">
                  <li>
                    Listing, advertising, offering, or facilitating the sale or
                    transfer of explosives of any kind, including but not
                    limited to improvised explosive devices (IEDs),
                    commercial-grade explosives, or explosive precursor
                    chemicals
                  </li>
                  <li>
                    Listing, advertising, or facilitating the sale of firearms,
                    whether licensed or unlicensed, through any feature of the
                    App including posts, comments, stories, groups, or direct
                    messages
                  </li>
                  <li>
                    Facilitating the sale or transfer of ammunition, including
                    bullets, cartridges, shells, or propellants, regardless of
                    calibre or type
                  </li>
                  <li>
                    Advertising or enabling the purchase of restricted firearm
                    accessories, specifically: bump stocks, gatling triggers,
                    drop-in auto sears, conversion kits of any type, and
                    magazines or ammunition belts with a capacity exceeding 30
                    rounds
                  </li>
                  <li>
                    Sharing links, referrals, or redirect codes to external
                    platforms that sell or facilitate the transfer of any of the
                    above items
                  </li>
                </ul>
                <h3>Manufacturing and Modification Instructions</h3>
                <ul className="mt-2 mb-2">
                  <li>
                    Publishing, sharing, or linking to instructions for the
                    manufacture, assembly, or home fabrication of explosives,
                    firearms, or ammunition
                  </li>
                  <li>
                    Sharing step-by-step guidance, tutorials, diagrams,
                    schematics, 3D-printable designs, or video demonstrations
                    for manufacturing or modifying any weapon or dangerous
                    product
                  </li>
                  <li>
                    Providing instructions, guides, or technical details for
                    converting any firearm from semi-automatic to automatic
                    firing capability
                  </li>
                  <li>
                    Sharing instructions or techniques for making a firearm
                    simulate automatic fire, including the use of bump stocks,
                    binary triggers, gatling triggers, or any other mechanical
                    or electronic means
                  </li>
                  <li>
                    Publishing guidance on bypassing, removing, or defeating any
                    firearm safety mechanism
                  </li>
                  <li>
                    Sharing information on acquiring explosive precursor
                    chemicals or combining legally available substances to
                    produce explosive compounds
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h3>2. Scope of Restricted Accessories</h3>
                <p>
                  For the avoidance of doubt, the following categories of
                  firearm accessories are considered restricted under this
                  policy and may not be promoted, sold, or instructed upon
                  through the App:
                </p>
                <ul>
                  <li>
                    Bump stocks and similar recoil-assisted devices that
                    replicate or increase the rate of fire of a semi-automatic
                    firearm
                  </li>
                  <li>
                    Gatling triggers, binary triggers, or any trigger mechanism
                    designed to fire on both the pull and release cycle to
                    simulate automatic fire
                  </li>
                  <li>
                    Drop-in auto sears (DIAS) or any internal component that
                    converts a semi-automatic firearm to fire automatically
                  </li>
                  <li>
                    Conversion kits of any description that alter the firing
                    mechanism, rate of fire, or classification of a firearm
                  </li>
                  <li>
                    Detachable magazines, drum magazines, or linked ammunition
                    belts with a capacity greater than 30 rounds
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h3>3. Automated and Human Moderation</h3>
                <p>
                  To enforce this policy effectively, we deploy a multi-layered
                  moderation system:
                </p>
                <ul>
                  <li>
                    Keyword and phrase detection algorithms continuously scan
                    public posts, comments, and captions for content patterns
                    associated with dangerous product sales or manufacturing
                    instructions
                  </li>
                  <li>
                    Image and video content moderation tools flag visual content
                    depicting weapon modifications, manufacturing processes, or
                    restricted accessories for human review
                  </li>
                  <li>
                    Link-scanning technology checks URLs shared on the platform
                    against databases of known illegal weapons marketplaces and
                    restricted content sources
                  </li>
                  <li>
                    Trained Trust &amp; Safety reviewers assess flagged content
                    within 24 hours, with priority escalation for content
                    involving imminent safety risks
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h3>4. Reporting Mechanism</h3>
                <p>
                  Any user who encounters content that may violate this policy
                  is encouraged to report it immediately:
                </p>
                <ul>
                  <li>
                    Tap the three-dot menu on any post, comment, story, or
                    profile and select "Report"
                  </li>
                  <li>
                    Choose the category "Dangerous Products / Weapons" and
                    provide a brief description
                  </li>
                  <li>
                    Your identity as the reporter is kept strictly confidential
                    and will not be disclosed to the reported user
                  </li>
                  <li>
                    You will receive a notification confirming receipt of your
                    report and a follow-up once the review is concluded
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h3>5. Enforcement Actions</h3>
                <p>
                  Confirmed violations of this policy will result in one or more
                  of the following actions, depending on severity:
                </p>
                <ul>
                  <li>
                    Immediate and permanent removal of the offending content
                  </li>
                  <li>
                    Temporary suspension of the associated account pending
                    further investigation
                  </li>
                  <li>
                    Permanent termination of the account with no right to
                    re-register
                  </li>
                  <li>
                    Device-level and IP-level restrictions to prevent account
                    evasion
                  </li>
                  <li>
                    Referral of evidence to Indian law enforcement authorities,
                    including the local police, the National Investigation
                    Agency (NIA), or other competent bodies, where content
                    indicates a violation of the Arms Act, 1959, the Explosives
                    Act, 1884, or any other applicable Indian law
                  </li>
                </ul>
              </ul>
              <ul className="mt-2">
                <h3>6. Data Handling in Dangerous Products Investigations</h3>
                <p>
                  Information collected during a dangerous products
                  investigation (including reported content, account metadata,
                  device information, and linked communication logs) is:
                </p>
                <ul>
                  <li>
                    Retained for a minimum of 180 days to support ongoing
                    investigations and potential legal proceedings
                  </li>
                  <li>
                    Accessible only to authorised Trust &amp; Safety personnel
                    and senior management on a strict need-to-know basis, with
                    full audit trails maintained
                  </li>
                  <li>
                    Shared with law enforcement or judicial authorities only in
                    response to a valid legal order or where there is a credible
                    and imminent risk to public safety
                  </li>
                  <li>
                    Never sold to, or shared with, third parties for commercial
                    or advertising purposes
                  </li>
                </ul>
              </ul>
            </ul>

            {/* 17.8 Marijuana */}
            <ul>
              <h2>17.8 Marijuana</h2>
              <p>
                Compliance with Google Play Marijuana Policy —{" "}
                <strong>No Facilitation Regardless of Legality</strong>
              </p>
              <p>
                Bharat Jagriti maintains an absolute prohibition on content that
                facilitates the sale of marijuana or marijuana products. This
                prohibition is unconditional and applies regardless of whether
                marijuana is legal, decriminalised, or medically authorised in
                the user's jurisdiction or any other jurisdiction in the world.
              </p>
              <h3>Sale and Commercial Facilitation</h3>
              <ul className="mt-2 mb-2">
                <li>
                  Listing, advertising, offering, or facilitating the sale,
                  purchase, trade, barter, gifting, or transfer of marijuana,
                  cannabis, or any marijuana-derived product in any form
                  whatsoever
                </li>
                <li>
                  Publishing pricing information, product availability, strain
                  descriptions, potency details, or product menus for any
                  marijuana product
                </li>
                <li>
                  Sharing vendor contact details, delivery service information,
                  sourcing channels, or order placement instructions for
                  marijuana products
                </li>
                <li>
                  Promoting, linking to, or directing users toward any marijuana
                  dispensary, online store, delivery service, or commercial
                  entity selling marijuana products, regardless of that entity's
                  licensing status
                </li>
                <li>
                  Creating or administering groups, communities, or pages on the
                  App that function as marketplaces or directories for marijuana
                  sales or procurement
                </li>
                <li>
                  Sharing referral links, discount codes, affiliate URLs, or
                  promotional offers associated with marijuana vendors,
                  dispensaries, or delivery platforms
                </li>
                <li>
                  Facilitating payment arrangements, barter offers, or exchange
                  agreements for marijuana products through any App feature
                  including posts, stories, comments, or direct messages
                </li>
              </ul>
              <ul className="mt-2 mb-2">
                <h3>Promotion and Indirect Facilitation</h3>
                <ul>
                  <li>
                    Publishing content that glorifies or commercially promotes
                    marijuana acquisition or consumption in a manner designed to
                    connect buyers and sellers
                  </li>
                  <li>
                    Using hashtags, keywords, coded language, emoji sequences,
                    or visual signals commonly used in commercial marijuana
                    sales contexts
                  </li>
                  <li>
                    Posting content that serves to signal product availability
                    or buyer interest in a marijuana commercial transaction,
                    even indirectly
                  </li>
                </ul>
              </ul>
              <ul className="mt-3">
                <h2>Absolute Nature of This Prohibition</h2>
                <p>
                  This prohibition applies without any exception. Content that
                  would otherwise violate this section cannot be justified on
                  the grounds that marijuana is legal in the user's location.
                  The prohibition is global and platform-wide.
                </p>
              </ul>
            </ul>

            {/* 17.9 Tobacco and Nicotine Products Policy */}
            <ul>
              <h2>17.9 Tobacco and Nicotine Products Policy</h2>
              <h3>Compliance with Google Play Policy — Tobacco and Nicotine</h3>
              <p>
                Bharat Jagriti does not allow the facilitation of the sale of
                tobacco or any product containing nicotine through our platform.
                We also prohibit content that encourages the illegal or
                inappropriate use of tobacco or nicotine products.
              </p>
              <ul className="mt-2 mb-2">
                <h3>1. Prohibited Content — Tobacco and Nicotine</h3>
                <h4>Sale Facilitation</h4>
                <ul className="mt-2 mb-2">
                  <li>
                    Listing, advertising, or facilitating the sale, purchase, or
                    transfer of any tobacco product including cigarettes,
                    beedis, cigars, pipe tobacco, chewing tobacco, gutka,
                    khaini, or raw tobacco
                  </li>
                  <li>
                    Facilitating the sale, trade, or distribution of any
                    electronic nicotine delivery system (ENDS) including
                    e-cigarettes, vape pens, pod systems, vaping liquids or
                    e-liquids, nicotine pouches, nicotine gums, or nicotine
                    patches through any App feature
                  </li>
                  <li>
                    Sharing pricing information, product availability, or vendor
                    contact details for any tobacco or nicotine product
                  </li>
                  <li>
                    Linking to or promoting external websites, apps, or delivery
                    services that sell tobacco or nicotine products
                  </li>
                  <li>
                    Creating groups, communities, or pages on the App that
                    function as sales channels or buyer-seller directories for
                    tobacco or nicotine products
                  </li>
                </ul>
                <ul className="mt-2 mb-2">
                  <h3>Encouraging Illegal or Inappropriate Use</h3>
                  <ul>
                    <li>
                      Targeting tobacco or nicotine promotional content at
                      minors (users under 18 years of age)
                    </li>
                    <li>
                      Publishing content that encourages or normalises tobacco
                      or nicotine use in contexts where it is illegal, such as
                      in educational institutions, healthcare premises, or other
                      smoke-free zones mandated by law
                    </li>
                    <li>
                      Sharing unverified health claims or misleading statements
                      that downplay the health risks of tobacco or nicotine use
                      in a manner that encourages uptake
                    </li>
                    <li>
                      Facilitating or glamorising tobacco or nicotine use in a
                      manner specifically designed to appeal to young or
                      underage audiences
                    </li>
                  </ul>
                </ul>
              </ul>
            </ul>

            {/* 17.10 Alcohol Policy */}
            <ul>
              <h2>17.10 Alcohol Policy</h2>
              <h3>Compliance with Google Play Alcohol Policy</h3>
              <p>
                Bharat Jagriti does not allow content that facilitates the
                illegal sale of alcohol or that encourages the illegal or
                inappropriate use of alcohol. While we recognise that alcohol is
                a legally regulated product in many Indian states, our platform
                will not be used to circumvent applicable laws or to target
                vulnerable groups including minors with alcohol-related content.
              </p>
              <ul className="mt-2">
                <h3>Prohibited Content — Alcohol</h3>
                <h3>Illegal Sale Facilitation</h3>
                <ul className="mt-1 mb-2">
                  <li>
                    Facilitating the sale, supply, or delivery of alcohol in
                    states or jurisdictions where the sale of alcohol is
                    completely prohibited (dry states), including Bihar,
                    Gujarat, Mizoram, and Nagaland
                  </li>
                  <li>
                    Facilitating the unlicensed sale of alcohol by individuals
                    or entities that do not hold a valid excise licence issued
                    by the relevant state government
                  </li>
                  <li>
                    Advertising or promoting the sale of illicitly produced or
                    counterfeit alcohol (such as spurious liquor) in any form
                  </li>
                  <li>
                    Facilitating alcohol delivery or procurement to minors
                    (persons under the legal drinking age applicable in the
                    relevant state, generally 18 or 21 years)
                  </li>
                </ul>
                <ul className="mt-1 mb-2">
                  <h3>Encouraging Illegal or Inappropriate Use</h3>
                  <ul>
                    <li>
                      Publishing content that encourages, glorifies, or
                      normalises underage drinking, including content
                      specifically designed to appeal to persons under the
                      applicable legal drinking age
                    </li>
                    <li>
                      Sharing content that encourages drinking and driving,
                      operating machinery under the influence, or other
                      behaviours that are illegal or pose a direct risk of harm
                      to the user or others
                    </li>
                    <li>
                      Publishing content that portrays alcohol consumption as a
                      solution to mental health challenges, grief, stress, or
                      personal difficulties in a manner that encourages harmful
                      or dependent use
                    </li>
                    <li>
                      Targeting alcohol-related promotional content at minors
                      through the use of youth-oriented imagery, influencers
                      known to have predominantly minor audiences, or
                      age-restricted features bypassed through platform misuse
                    </li>
                    <li>
                      Promoting alcohol in contexts where its use is legally
                      prohibited, such as during dry days, in dry zones, or
                      within proximity of schools and religious institutions as
                      defined by applicable law
                    </li>
                    <li>
                      Sharing content that encourages binge drinking, harmful
                      drinking games, or any form of alcohol use that poses an
                      imminent health or safety risk
                    </li>
                  </ul>
                </ul>
              </ul>
            </ul>
          </section>

          {/* 18. Financial Services */}
          <section>
            <h1>18. Financial Services</h1>
            <p>
              Bharat Jagriti doesn't allow users to expose deceptive or harmful
              financial products and services.
            </p>
            <p>
              Bharat Jagriti doesn't allow financial products and services to be
              those related to the management or investment of money and
              cryptocurrencies, including personalised advice.
            </p>
            <h3>1. Binary Options</h3>
            <ul>
              <li>
                Bharat Jagriti doesn't provide users with the ability to trade
                binary options.
              </li>
            </ul>
            <h3>2. Loan</h3>
            <ul>
              <li>
                Bharat Jagriti is not a lending platform and does not provide
                any kind of loan or any other financial services.
              </li>
            </ul>
            <h3>
              3. Real-Money Gambling, Games, Contests, and Tournament Apps
            </h3>
            <ul>
              <li>
                Bharat Jagriti is not a real money gambling, Games, Contests, or
                a Tournament app and does not provide any kind of such services.
              </li>
            </ul>
          </section>

          {/* 19. Illegal Activities */}
          <section>
            <h1>19. Illegal Activities</h1>
            <p>
              Bharat Jagriti is committed to maintaining a safe and lawful
              digital environment for all users. Our platform strictly prohibits
              and does not facilitate or promote any illegal activities. We
              actively monitor content, enforce policies, and take necessary
              action against violations to ensure compliance with applicable
              laws of the Indian Government.
            </p>
          </section>

          {/* 20. Health Content and Services */}
          <section>
            <h1>20. Health Content and Services</h1>
            <p>
              Bharat Jagriti is a social media and community engagement
              platform. It is NOT a medical device, clinical tool, or licensed
              healthcare application. Any health-related content shared on this
              platform is provided for general informational and awareness
              purposes only. This App does NOT provide medical diagnosis,
              clinical advice, treatment recommendations, or any regulated
              medical service. Always consult a qualified, licensed healthcare
              professional before making any health or medical decisions. In
              case of a medical emergency, call 112 (India Emergency Services)
              immediately.
            </p>
          </section>

          {/* 21. Blockchain-based Content */}
          <section>
            <h1>21. Blockchain-based Content</h1>
            <p>
              At Bharat Jagriti, we are committed to maintaining a safe,
              transparent, and policy-compliant digital environment for all
              users. In accordance with Google Play policies, we explicitly
              clarify our stance regarding blockchain-based technologies and
              related content.
            </p>
            <ul>
              <h2>1. No Blockchain Integration</h2>
              <p>
                Bharat Jagriti does not use, support, or integrate any
                blockchain-based technologies within its platform. This
                includes, but is not limited to:
              </p>
              <ul>
                <li>Cryptocurrencies (e.g., Bitcoin, Ethereum)</li>
                <li>Non-Fungible Tokens (NFTs)</li>
                <li>Decentralized applications (DApps)</li>
                <li>Tokenized rewards or digital assets</li>
              </ul>
            </ul>
            <ul>
              <h2>2. No Financial or Crypto Transactions</h2>
              <p>Our platform does not facilitate:</p>
              <ul>
                <li>
                  Buying, selling, or trading of cryptocurrencies or digital
                  assets
                </li>
                <li>Wallet services or token exchanges</li>
                <li>Any blockchain-based financial transactions</li>
              </ul>
            </ul>
            <ul>
              <h2>3. No Promotion of Blockchain Content</h2>
              <p>Users are not permitted to:</p>
              <ul>
                <li>
                  Promote or advertise cryptocurrency schemes, NFT projects, or
                  token sales
                </li>
                <li>
                  Share misleading or fraudulent blockchain-related investment
                  opportunities
                </li>
                <li>
                  Engage in activities that may violate financial or digital
                  asset regulations
                </li>
              </ul>
            </ul>
            <ul>
              <h2>4. Compliance with Google Play Policies</h2>
              <p>
                Bharat Jagriti fully complies with Google Play's Developer
                Program Policies and ensures that:
              </p>
              <ul>
                <li>No blockchain-related monetization features are present</li>
                <li>No unauthorized financial services are offered</li>
                <li>
                  The platform remains free from speculative or high-risk
                  financial content
                </li>
              </ul>
            </ul>
          </section>

          {/* 22. AI-Generated Content */}
          <section>
            <h1>22. AI-Generated Content</h1>
            <p>
              At Bharat Jagriti, we are committed to ensuring a safe,
              responsible, and transparent environment for all users. This
              policy outlines our approach to AI-generated content in compliance
              with Google Play Developer Policies.
            </p>
            <ul>
              <h3>1. Use of AI-Generated Content</h3>
              <p>
                Bharat Jagriti may incorporate generative AI technologies to
                enhance user experience, including:
              </p>
              <ul>
                <li>
                  Text-based interactions (e.g., AI chat or content suggestions)
                </li>
                <li>
                  AI-assisted content creation (posts, captions, or media
                  enhancements)
                </li>
              </ul>
              <p>
                All AI-generated content is created based on user inputs and is
                subject to moderation and platform guidelines.
              </p>
            </ul>
            <ul>
              <h2>2. Prohibition of Restricted Content</h2>
              <p>
                We strictly prohibit the generation, sharing, or promotion of
                any AI-generated content that violates Google Play policies or
                applicable laws, including but not limited to:
              </p>
              <li>Content involving child sexual abuse or exploitation</li>
              <li>Harmful, abusive, or violent content</li>
              <li>Misleading or deceptive information</li>
              <li>Hate speech, harassment, or unlawful activities</li>
              <p>
                Bharat Jagriti implements safeguards to prevent and restrict the
                generation of such content through AI systems.
              </p>
            </ul>
            <ul>
              <h2>3. Content Moderation and Safety Measures</h2>
              <p>To maintain platform integrity:</p>
              <ul>
                <li>
                  AI-generated content is subject to automated filtering and
                  human moderation
                </li>
                <li>
                  We continuously improve our AI systems to detect and block
                  harmful outputs
                </li>
                <li>
                  User activity may be monitored to prevent misuse of AI
                  features
                </li>
              </ul>
            </ul>
          </section>

          {/* 23. Age-Restricted Content and Functionality Policy */}
          <section>
            <h1>23. Age-Restricted Content and Functionality Policy</h1>
            <p>
              At Bharat Jagriti, we prioritize user safety and adhere strictly
              to Google Play Developer Policies regarding age-appropriate access
              and content.
            </p>
            <ul>
              <h3>1. Nature of the Platform</h3>
              <p>
                Bharat Jagriti is a general social media platform designed for
                users to share content, engage in discussions, and build
                communities.
              </p>
              <ul>
                <li>We do not provide dating or matchmaking services</li>
                <li>
                  We do not facilitate real money gambling, games, or contests
                </li>
                <li>
                  The platform is not classified as an age-restricted (18+)
                  application
                </li>
              </ul>
            </ul>
            <ul>
              <h3>2. Age Eligibility and Registration Policy</h3>
              <p>To ensure the safety of minors:</p>
              <ul>
                <li>
                  Users below 13 years of age are not permitted to register or
                  use Bharat Jagriti
                </li>
                <li>
                  Users aged 13 to 18 years may access the platform only under
                  parental guidance and supervision
                </li>
                <li>
                  Users 18 years and above can freely access and use all
                  standard features of the platform
                </li>
              </ul>
              <p>
                We implement appropriate age checks during registration to
                enforce these requirements.
              </p>
            </ul>
          </section>

          {/* 24. User-Generated Content (UGC) Policy */}
          <section>
            <h1>24. User-Generated Content (UGC) Policy</h1>
            <p>
              Bharat Jagriti is a social media platform where users can create,
              share, and interact with content publicly or within defined user
              groups. As a UGC platform, we maintain robust, effective, and
              ongoing content moderation practices in full compliance with
              Google Play Store's User-Generated Content Policy.
            </p>
            <ul>
              <h2>1. Acceptance of Terms Before Posting</h2>
              <p>
                All users must explicitly accept Bharat Jagriti's Terms of Use
                and Community Guidelines before they can create an account, post
                content, comment, share, or upload any material on the platform.
                Access to UGC features is conditional upon this acceptance.
                Users who do not accept these terms will not be permitted to
                contribute content.
              </p>
            </ul>
            <ul>
              <h2>2. Objectionable Content &amp; Prohibited Behaviours</h2>
              <p>
                Bharat Jagriti's Terms of Use clearly define and strictly
                prohibit the following types of objectionable content and user
                behaviour:
              </p>
              <ul>
                <li>
                  Hate speech, discrimination, or content targeting individuals
                  or groups based on religion, caste, race, gender, sexual
                  orientation, disability, or nationality
                </li>
                <li>
                  Sexually explicit, obscene, or pornographic content of any
                  kind
                </li>
                <li>
                  Content that endangers, exploits, or sexualises minors in any
                  manner
                </li>
                <li>
                  Graphic violence, gore, self-harm, or content that glorifies
                  dangerous activities
                </li>
                <li>
                  Harassment, bullying, threats, stalking, or intimidation of
                  any user
                </li>
                <li>
                  Misinformation, fake news, or content designed to deceive or
                  manipulate
                </li>
                <li>
                  Spam, phishing, malware links, or fraudulent promotional
                  content
                </li>
                <li>
                  Content that infringes intellectual property rights of any
                  third party
                </li>
                <li>
                  Content that incites violence, terrorism, or unlawful
                  activities
                </li>
                <li>
                  Impersonation of any person, organisation, or public figure
                </li>
                <li>
                  Content that violates any applicable Indian law or
                  international regulation
                </li>
              </ul>
            </ul>
            <ul>
              <h2>3. Content Moderation Practices</h2>
              <p>
                We conduct active, ongoing moderation of user-generated content
                through a combination of automated systems and human review. Our
                moderation framework includes:
              </p>
              <ul>
                <li>
                  Automated detection of prohibited content using AI-powered
                  filtering tools
                </li>
                <li>
                  Human moderator review of reported content, escalated posts,
                  and flagged accounts
                </li>
                <li>
                  Pre-publication screening for new accounts and high-risk
                  content categories
                </li>
                <li>
                  Periodic audits of trending and viral content for policy
                  compliance
                </li>
                <li>
                  Zero-tolerance enforcement for child endangerment and illegal
                  content
                </li>
              </ul>
            </ul>
            <ul>
              <h2>4. In-App Reporting &amp; Blocking System</h2>
              <p>
                In compliance with Google Play's UGC policy, Bharat Jagriti
                provides the following in-app tools for all users:
              </p>
              <ul>
                <li>
                  <strong>Report Content:</strong> Any post, comment, image,
                  video, or story can be reported directly via a Report button
                  available on every piece of content.
                </li>
                <li>
                  <strong>Report User:</strong> Any user profile can be reported
                  for violations directly from their profile page.
                </li>
                <li>
                  <strong>Block User:</strong> Users can block any other user at
                  any time, preventing all interaction including direct
                  messages, mentions, tags, and content visibility.
                </li>
              </ul>
              <p>
                All reports are reviewed within 24-48 hours. We take appropriate
                action including content removal, account warning, suspension,
                or permanent ban depending on the severity of the violation.
              </p>
            </ul>
            <ul>
              <h2>5. Direct Messaging &amp; 1:1 Interaction Safeguards</h2>
              <p>
                For features enabling direct one-to-one user interaction such as
                private messaging, tagging, and mentions, Bharat Jagriti
                provides:
              </p>
              <ul>
                <li>
                  In-app block functionality to immediately prevent any further
                  contact from a specific user.
                </li>
                <li>
                  The user cannot send a message to anybody directly until the
                  other user accepts the message request.
                </li>
                <li>
                  Message request filtering for users who are not mutual
                  connections.
                </li>
                <li>
                  Reporting tools accessible directly within the direct message
                  conversation window.
                </li>
              </ul>
            </ul>
            <ul>
              <h2>6. Monetisation Safeguards</h2>
              <p>
                Bharat Jagriti ensures that in-app monetisation features do not
                incentivise or reward objectionable user behaviour:
              </p>
              <ul>
                <li>
                  Monetisation eligibility is restricted to accounts in good
                  standing with no active policy violations
                </li>
                <li>
                  Content that violates community guidelines is ineligible for
                  promotion, boosting, or revenue-sharing features
                </li>
                <li>
                  Accounts generating revenue through objectionable content will
                  have monetisation privileges permanently revoked
                </li>
                <li>
                  We do not display advertisements on reported or flagged
                  content pending moderation review
                </li>
              </ul>
            </ul>
            <ul>
              <h2>7. Consequences of UGC Violations</h2>
              <p>
                Users found in violation of our UGC policy will be subject to
                one or more of the following actions based on severity:
              </p>
              <ul>
                <li>Immediate content removal without prior notice</li>
                <li>Formal warning issued to the user's registered contact</li>
                <li>
                  Temporary suspension of posting, commenting, or messaging
                  privileges
                </li>
                <li>Permanent account suspension or termination</li>
                <li>
                  Reporting to relevant law enforcement or regulatory
                  authorities where legally required
                </li>
              </ul>
            </ul>
          </section>

          {/* 25. Intellectual Property Rights & Content Policy */}
          <section>
            <h1>25. Intellectual Property Rights &amp; Content Policy</h1>
            <p>
              Bharat Jagriti is fully committed to respecting the intellectual
              property rights of all individuals, creators, and rights holders.
              In accordance with Google Play Store policies, the following rules
              apply to all users:
            </p>
            <ul>
              <h2>1. Prohibition on IP Infringement</h2>
              <p>
                Users must NOT upload, share, post, or distribute any content on
                Bharat Jagriti that:
              </p>
              <ul>
                <li>
                  Infringes upon copyright, trademark, patent, trade secret, or
                  any other proprietary rights of any third party
                </li>
                <li>
                  Is copied from another work without appropriate permission,
                  licence, or constitutes fair use
                </li>
                <li>
                  Contains counterfeit, misleading, or impersonated branding,
                  logos, or trademarks
                </li>
                <li>
                  Reproduces or replicates patented inventions, designs, or
                  processes without authorisation
                </li>
                <li>
                  Encourages, induces, or facilitates others to infringe upon
                  intellectual property rights
                </li>
              </ul>
            </ul>
            <ul>
              <h2>2. User-Generated Content Ownership</h2>
              <p>
                You retain ownership of the original content you create and post
                on Bharat Jagriti. By posting content, you grant Bharat Jagriti
                a non-exclusive, royalty-free, worldwide licence to display,
                distribute, and promote your content within the App.
              </p>
              <p>
                You represent and warrant that you own or have the necessary
                rights, licences, and permissions for all content you submit.
                You shall bear sole responsibility for any content that
                infringes third-party intellectual property rights.
              </p>
            </ul>
            <ul>
              <h2>3. Registered Trademark — Bharat Jagriti</h2>
              <p>
                "BHARAT JAGRITI" is a registered trademark of GlowApps Private
                Limited, duly registered under the Trade Marks Act, 1999 with
                the Trade Marks Registry, Government of India. The trademark
                covers online social networking services and is protected under
                Indian law.
              </p>
              <p>
                The name, logo, brand identity, and all associated marks of
                “Bharat Jagriti” are the exclusive intellectual property of
                GlowApps Private Limited. All rights are fully reserved.
                Unauthorised use, reproduction, imitation, or misappropriation
                of the Bharat Jagriti trademark — in whole or in part — is
                strictly prohibited and constitutes an infringement punishable
                under the Trade Marks Act, 1999, and applicable international
                conventions including the Paris Convention and the TRIPS
                Agreement.
              </p>
              <p>
                Any third party found to be infringing upon the Bharat Jagriti
                trademark shall be subject to legal action including civil
                injunctions, damages, and criminal prosecution as permissible
                under applicable law.
              </p>
            </ul>
          </section>

          {/* 26. Permissions and APIs that Access Sensitive Information */}
          <section>
            <h1>26. Permissions and APIs that Access Sensitive Information</h1>
            <p>
              Bharat Jagriti requests only the minimum permissions necessary to
              provide the app's core features. All permissions and APIs that
              access sensitive user information are requested only when
              genuinely required, and only with the user's explicit, informed
              consent. Sensitive data is never misused, under-disclosed, or
              accessed unnecessarily.
            </p>
            <p>Bharat Jagriti's commitments under this policy:</p>
            <ul>
              <li>
                Permissions such as Camera and Gallery access are requested only
                at the moment the user actively initiates the relevant action —
                never in the background or automatically. (See Section 4 for
                full details.)
              </li>
              <li>
                All permission requests are accompanied by a clear explanation
                of why the permission is needed and how the data will be used.
              </li>
              <li>
                Users can deny or revoke any permission at any time via device
                Settings without losing core app functionality.
              </li>
              <li>
                Bharat Jagriti does not use any accessibility APIs, device
                administrator APIs, or system-level APIs to autonomously execute
                actions without the user's knowledge or consent.
              </li>
              <li>
                No sensitive body sensor, location, or contact data is collected
                unless explicitly required and disclosed for a specific app
                feature.
              </li>
              <li>
                Any use of sensitive APIs complies with Google Play's
                Permissions and APIs policy and applicable Indian privacy laws.
              </li>
            </ul>
          </section>

          {/* 27. Device and Network Abuse */}
          <section>
            <h1>27. Device and Network Abuse</h1>
            <p>
              Bharat Jagriti does not allow any content, code, or behaviour —
              whether from the app itself or from third-party SDKs integrated
              into it — that interferes with, disrupts, damages, or accesses in
              an unauthorised manner the user's device, other devices, networks,
              APIs, or services.
            </p>
            <p>The following are strictly prohibited on Bharat Jagriti:</p>
            <ul>
              <li>
                Introducing or exploiting security vulnerabilities in devices,
                networks, or other apps.
              </li>
              <li>
                Performing or facilitating hacking, cracking, or unauthorised
                access to any system, service, or account.
              </li>
              <li>
                Downloading or executing unauthorised code, scripts, or
                executable files on a user's device.
              </li>
              <li>
                Interfering with or blocking other apps, services, or
                advertisements on a user's device.
              </li>
              <li>
                Changing user device settings without explicit user knowledge
                and consent.
              </li>
              <li>
                Preventing users from disabling or uninstalling any app or
                service without authorisation.
              </li>
              <li>
                Working around Android's built-in platform security controls or
                privacy notifications.
              </li>
              <li>
                Using the platform to facilitate Distributed Denial of Service
                (DDoS) attacks or any other network abuse.
              </li>
            </ul>
          </section>

          {/* 28. Deceptive Behavior */}
          <section>
            <h1>28. Deceptive Behavior</h1>
            <p>
              Bharat Jagriti does not allow users or content on the platform
              that attempts to deceive other users or enable dishonest behaviour
              in any way. All information presented on the platform must be
              accurate, honest, and not misleading. Any changes to device
              settings must be made with the user's full knowledge and consent,
              and must be reversible.
            </p>
            <p>Examples of deceptive behaviour that are strictly prohibited:</p>
            <ul>
              <li>
                Posting content that misrepresents or falsely describes a
                product, service, person, or organisation.
              </li>
              <li>
                Content that mimics or impersonates system notifications,
                security warnings, or official communications from Bharat
                Jagriti or other trusted authorities to trick users into taking
                action.
              </li>
              <li>
                Apps, links, or tools shared on the platform that are
                functionally deceptive — such as claiming impossible features
                (e.g., fake virus scanners, fake signal boosters, fake speed
                testers).
              </li>
              <li>
                Generating or facilitating the generation of fake identity
                documents — such as fake ID cards, passports, diplomas, credit
                cards, bank account details, or driving licences.
              </li>
              <li>
                Content or behaviour that attempts to mislead users about the
                source, authenticity, or affiliation of a post, account, or
                piece of information.
              </li>
              <li>
                Sharing links or content that redirects users to malicious,
                phishing, or deceptive websites.
              </li>
            </ul>
            <p className="privacy_policy_note">
              ■ Note: Claiming that content is a 'prank', 'for entertainment',
              or 'just a joke' does not exempt it from this policy. Bharat
              Jagriti will remove deceptive content regardless of how it is
              labelled.
            </p>
          </section>

          {/* 29. Misrepresentation */}
          <section>
            <h1>29. Misrepresentation</h1>
            <p>
              Bharat Jagriti prohibits users and accounts from misrepresenting
              or concealing their true identity, ownership, country of origin,
              or primary purpose on the platform. Coordinated inauthentic
              behaviour — where multiple accounts or external actors work
              together to mislead other users — is strictly prohibited,
              especially on matters involving politics, social issues, or public
              concern.
            </p>
            <p>Examples of misrepresentation that are strictly prohibited:</p>
            <ul>
              <li>
                Creating accounts that impersonate a real person, organisation,
                government body, or public figure.
              </li>
              <li>
                Misrepresenting or concealing the true ownership, funding
                source, or primary purpose of an account or campaign on the
                platform.
              </li>
              <li>
                Coordinating with other accounts, websites, or external actors
                to mislead users about the origin, authenticity, or scale of a
                movement, opinion, or piece of content.
              </li>
              <li>
                Faking a country of origin to target users in another country
                with misleading or manipulative content.
              </li>
              <li>
                Using multiple accounts to artificially inflate the perceived
                popularity or support for a viewpoint, person, product, or
                campaign.
              </li>
              <li>
                Disguising the commercial, political, or ideological nature of
                content to make it appear organic or user-generated when it is
                not.
              </li>
            </ul>
          </section>

          {/* 30. Bharat Jagriti Target API Level Policy */}
          <section>
            <h1>30. Bharat Jagriti Target API Level Policy</h1>
            <p>
              To ensure that Bharat Jagriti delivers the best possible security,
              performance, and user experience, the app complies fully with
              Google Play's Target API Level Policy. This policy requires apps
              to target a recent Android API level so that users benefit from
              the latest security and privacy improvements introduced with each
              new Android version.
            </p>
            <p>Bharat Jagriti's compliance with the Target API Level Policy:</p>
            <ul>
              <li>
                New app updates always target an Android API level within one
                year of the latest major Android version release, in full
                compliance with Google Play's submission requirements.
              </li>
              <li>
                Existing app versions target an API level within two years of
                the latest major Android release to remain available to new
                users on newer Android devices.
              </li>
              <li>
                As of the current effective date of this policy, Bharat Jagriti
                targets Android 15 (API level 35) or higher, meeting Google
                Play's latest requirements.
              </li>
              <li>
                The app is regularly updated to adopt new Android security
                patches, privacy controls, and platform improvements introduced
                with each major Android release.
              </li>
              <li>
                Bharat Jagriti does not use deprecated or insecure APIs that
                have been removed or restricted in newer Android versions.
              </li>
            </ul>
            <p className="privacy_policy_note">
              ■ Note: Targeting a current API level ensures that Bharat Jagriti
              benefits from Android's latest security hardening, runtime
              permission model, background activity restrictions, and privacy
              sandbox improvements — all of which directly protect our users'
              data and device integrity.
            </p>
          </section>

          {/* 31. Third-Party Links and Services */}
          <section>
            <h1>31. Third-Party Links and Services</h1>
            <p>
              The platform may contain links to external websites or embed
              content from third-party services (such as YouTube live streams
              via YouTube API). This Privacy Policy does not apply to such
              third-party services. We encourage you to review the privacy
              policies of any third-party services you access through our
              platform.
            </p>
          </section>

          {/* 32. Advertising Disclosure */}
          <section>
            <h1>32. Advertising Disclosure</h1>
            <p>
              As required by Google Play, we declare our advertising practices
              below:
            </p>
            <ul>
              <li>
                📢 Bharat Jagriti may display advertisements within the app.
                This will be clearly marked with a 'Contains Ads' label on our
                Play Store listing.
              </li>
              <li>
                🚫 We do not serve personalised ads based on religion, caste,
                political affiliation, health conditions, or any sensitive
                personal attribute.
              </li>
              <li>🚫 We do not sell your data to advertisers.</li>
              <li>
                ✅ Any ads displayed are contextual (based on content category)
                or demographic (age range, general location) only.
              </li>
              <li>
                ✅ All advertising partners are required to comply with Google
                Play advertising policies and applicable data protection laws.
              </li>
              <li>
                🧒 No behavioural or targeted advertising is served to users
                aged 13–17.
              </li>
            </ul>
          </section>

          {/* 33. Platform Neutrality */}
          <section>
            <h1>33. Platform Neutrality</h1>
            <p>
              Bharat Jagriti is an independent, neutral social media platform
              committed to providing a fair, unbiased, and inclusive space for
              all citizens of India regardless of their beliefs, background, or
              affiliations.
            </p>
            <ul>
              <h2>1. No Representation of Any Religion</h2>
              <p>
                Bharat Jagriti does not represent, promote, endorse, or
                affiliate with any specific religion, religious group, sect, or
                faith. The platform does not favour or discriminate against any
                religion and welcomes users of all religions, faiths, and
                beliefs equally. Content that promotes religious hatred,
                discrimination, or violence will be removed.
              </p>
            </ul>
            <ul>
              <h2>2. No Representation of Any Political Party</h2>
              <p>
                Bharat Jagriti does not represent, promote, endorse, or
                affiliate with any political party, political ideology, or
                electoral candidate. The platform is not funded by, controlled
                by, or associated with any political party, and treats users of
                all political affiliations equally and without bias.
              </p>
            </ul>
            <ul>
              <h2>3. User-Generated Content Disclaimer</h2>
              <p>
                Content posted by users on Bharat Jagriti reflects the personal
                opinions and views of individual users only. Such content does
                not represent the views, opinions, or positions of Bharat
                Jagriti, its founders, employees, or administrators. Bharat
                Jagriti is not and never responsible for the content posted by
                any user.
              </p>
            </ul>
            <ul>
              <h2>4. Equal Treatment Policy</h2>
              <p>
                Bharat Jagriti is committed to equal treatment of all users
                irrespective of their:
              </p>
              <ul>
                <li>Religion, faith, or spiritual belief</li>
                <li>Political affiliation or ideology</li>
                <li>Caste, community, or ethnicity</li>
                <li>Gender, age, or regional background</li>
                <li>Language or cultural identity</li>
              </ul>
            </ul>
            <p className="privacy_policy_note">
              ■ Note: Any user found using the platform to promote hatred,
              division, or discrimination on the basis of religion or political
              affiliation will have their account permanently suspended.
            </p>
          </section>

          {/* 34. Governing Law */}
          <section>
            <h1>34. Governing Law</h1>
            <p>
              This Privacy Policy is governed by and construed in accordance
              with the laws of India, including the Information Technology Act,
              2000, the Information Technology (Amendment) Act, 2008, the
              Digital Personal Data Protection Act, 2023, and the applicable
              rules thereunder. Any disputes arising from this policy shall be
              subject to the exclusive jurisdiction of the courts of India.
            </p>
          </section>

          {/* 35. Contact Us */}
          <section>
            <h1>35. Contact Us</h1>
            <p>
              If you have any questions, concerns, or requests regarding this
              Privacy Policy, your personal data, or to exercise any of your
              rights, please contact us:
            </p>
            <ul>
              <li>Name: Bhaskar Bhushan</li>
              <li>Designation: CEO, Bharat Jagriti</li>
              <li>Email: ceo@bharatjagriti.com</li>
              <li>Website: https://www.bharatjagriti.com/</li>
              <li>
                Privacy Policy URL: https://www.bharatjagriti.com/privacy-policy
              </li>
            </ul>
          </section>

          {/* 36. Grievance Redressal */}
          <section>
            <h1>36. Grievance Redressal</h1>
            <p>
              In accordance with the Information Technology Act, 2000, and the
              Information Technology (Intermediary Guidelines and Digital Media
              Ethics Code) Rules, 2021, we have appointed a Grievance Officer to
              address your privacy concerns.
            </p>
            <p>
              <strong>Grievance Officer:</strong>
            </p>
            <ul>
              <li>Name: Aditya Mishra</li>
              <li>Contact number: 751 889 1106</li>
              <li>Email: grievance@bharatjagriti.com</li>
              <li>
                Address: GLOWAPPS PRIVATE LIMITED, Near Medical College Boys
                Hostel, Beside Yamaha Showroom, Colony Indrapuri, Bettiah West
                Champaran BR 845438, INDIA.
              </li>
            </ul>
            <p>
              You may file a complaint or concern within 3 months of the
              relevant incident. We will acknowledge receipt within 24 hours and
              resolve complaints within 15 days of receipt.
            </p>
          </section>

          {/* 37. Changes to This Privacy Policy */}
          <section>
            <h1>37. Changes to This Privacy Policy</h1>
            <p>
              We reserve the right to update this Privacy Policy at any time.
              When we do, we will notify you through the App or via email. The
              "Last Updated" date at the top of this document reflects the most
              recent revision. Your continued use of the App after any changes
              constitutes acceptance of the revised policy.
            </p>
          </section>

          {/* 38. User Consent */}
          <section>
            <h1>38. User Consent</h1>
            <p>
              By registering on or using the Bharat Jagriti platform, you
              explicitly consent to agree to our privacy policy and to the
              collection, storage, use, and disclosure of your information as
              described in this Privacy Policy. You may withdraw your consent at
              any time by deleting your account; however, this will not affect
              the lawfulness of any processing carried out prior to the
              withdrawal of consent.
            </p>
          </section>

          {/* Footer */}
          <div className="footer-note">
            <p>
              For any privacy concerns, contact us at: ceo@bharatjagriti.com
            </p>
            <p>© 2026 Bharat Jagriti — All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;